import './global.js'
import './singlepost.css'
import Parse from 'parse';
import React, { useState, useEffect } from 'react';
import Recipe from "./recipe.jsx";
import Product from "./product.jsx";
import { Route, Link} from "react-router-dom";
import $ from "jquery";
import { MentionsInput, Mention } from 'react-mentions';
import defaultStyle from './defaultStyle'
import defaultMentionStyle from './defaultMentionStyle'
import './MentionTextarea.css';
import Leftsidebar from "./Leftsidebar.jsx";
  function time_ago(time) {

    switch (typeof time) {
      case 'number':
        break;
      case 'string':
        time = +new Date(time);
        break;
      case 'object':
        if (time.constructor === Date) time = time.getTime();
        break;
      default:
        time = +new Date();
    }
    var time_formats = [
      [60, 's', 1], // 60
      [120, '1m', '1 minute from now'], // 60*2
      [3600, 'm', 60], // 60*60, 60
      [7200, '1h', '1 hour from now'], // 60*60*2
      [86400, 'h', 3600], // 60*60*24, 60*60
      [172800, '1d', 'Tomorrow'], // 60*60*24*2
      [604800, 'd', 86400], // 60*60*24*7, 60*60*24
      [1209600, '1w', 'Next week'], // 60*60*24*7*4*2
      [2419200, 'w', 604800], // 60*60*24*7*4, 60*60*24*7
      [4838400, '1m', 'Next month'], // 60*60*24*7*4*2
      [29030400, 'm', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
      [58060800, '1y', 'Next year'], // 60*60*24*7*4*12*2
      [2903040000, 'y', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
      [5806080000, 'Last century', 'Next century'], // 60*60*24*7*4*12*100*2
      [58060800000, 'centuries', 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
    /* [60, 'seconds', 1], // 60
      [120, '1 minute ago', '1 minute from now'], // 60*2
      [3600, 'minutes', 60], // 60*60, 60
      [7200, '1 hour ago', '1 hour from now'], // 60*60*2
      [86400, 'hours', 3600], // 60*60*24, 60*60
      [172800, 'Yesterday', 'Tomorrow'], // 60*60*24*2
      [604800, 'days', 86400], // 60*60*24*7, 60*60*24
      [1209600, 'Last week', 'Next week'], // 60*60*24*7*4*2
      [2419200, 'weeks', 604800], // 60*60*24*7*4, 60*60*24*7
      [4838400, 'Last month', 'Next month'], // 60*60*24*7*4*2
      [29030400, 'months', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
      [58060800, 'Last year', 'Next year'], // 60*60*24*7*4*12*2
      [2903040000, 'years', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
      [5806080000, 'Last century', 'Next century'], // 60*60*24*7*4*12*100*2
      [58060800000, 'centuries', 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100*/
    ];
    var seconds = (+new Date() - time) / 1000,
    // token = 'ago',
      token = '',
      list_choice = 1;

    if (seconds == 0) {
    // return 'Just now'
      return ''
    }
    if (seconds < 0) {
      seconds = Math.abs(seconds);
      //token = 'from now';
      token = '';
      list_choice = 2;
    }
    var i = 0,
      format;
    while (format = time_formats[i++])
      if (seconds < format[0]) {
        if (typeof format[2] == 'string')
          return format[list_choice];
        else
        // return Math.floor(seconds / format[2]) + ' ' + format[1] + ' ' + token;
          return Math.floor(seconds / format[2]) + '' + format[1] + '' + token;
      }
    return time;
  }

  class Singlepostoverly extends React.Component {
      constructor(props) {
        super(props);

        Parse.initialize("ze4eQAdmycW7e8MCskILkfGFUNdwYnsKSsZDi0t5", "sDC1XmRXe4bP5i1VqhBhy8cIdiWrBpJmvtmmwvIw"); //PASTE HERE YOUR Back4App APPLICATION ID AND YOUR JavaScript KEY
        Parse.serverURL = "https://parse.joelskitchen.com/parse";
        //Parse.serverURL = "https://parsetest.joelskitchen.com/parse";

        var now = new Date();
        
        
        this.state = {
            postID: 0,
            postData: null,
            created_at: now.getTime(),
            comments: null,
            postImage: null,
            userImage: null,
            user: null,
            caption: null,
            likeCount: 0,
            saveCount: 0,
            commentCount: 0,
            recipe: null,
            product: null,
            city: null,
            postcomment:'',
            isChallenge: "0",
            CurrentSaveCount: 0,
            currentuserImage: null,
            currentUserId: null,
            singlelikeCount:0,
            isExpanded:false,
            expandedCommentId:null,
            blank_comment_message:null,
            challengeStatus: null,
            singlementioned:'',
            singleget_allusers:[],
            linkdata:'',
            loadpage:'home',
            getUsernamefetch:null,
            usertype:0,
            popup_username:null,            
            popup_comments:null,
            comments_data:null,
            likeCount1: 0,
            likeuserlist:[],
        };

        //load vals from post objects

        //temp cheese
        var result = props.postData;

        //console.log("********************************");
        // console.log("RESULT: ", JSON.stringify(result));
        // console.log("USER: ", JSON.stringify(result.get("user")));
        // console.log("================================");
        // if (result.get("user") != undefined)
        //  console.log("Username: ", result.get("user").get("displayUsername"));
        // else
        //   console.log("UNDEFINED USER");
        
        if (result.get("image"))  {
          //console.log("Image: ", result.get("image").url());
          this.state.postImage = result.get("image").url();
        }
        if (result.get("isChallenge")) {
          //console.log("Image: ", result.get("image").url());
          this.state.isChallenge = result.get("isChallenge");
        }
      
        this.state.user = result.get("user");
        const currentUser = Parse.User.current();

        if(currentUser != null) {
          if((currentUser.get("isCreator")!==undefined && currentUser.get("isCreator")===1) || (currentUser.get("isBusiness")!==undefined && currentUser.get("isBusiness")===1) || (currentUser.get("isAdmin")!==undefined && currentUser.get("isAdmin")==="1"))
          {
            this.state.usertype=1;
          }

        
        }
        
        this.state.username = result.get("user").get("displayUsername");
        //new code
        if(this.state.user)
        {
          this.state.getUsernamefetch= this.state.username;
          if ((!this.state.getUsernamefetch) || (this.state.getUsernamefetch.length < 2)) 
          {
            this.state.getUsernamefetch = this.state.user.get("firstName") + "_" + this.state.user.get("lastName");
            this.state.getUsernamefetch = this.state.getUsernamefetch.toLowerCase(this.state.getUsernamefetch);
          }
        }
        //new code

        if (result.get("user").get("profilePictureSmall")) {
          //console.log("User image: ", result.get("user").get("profilePictureSmall").url());
          this.state.userImage = result.get("user").get("profilePictureSmall").url();
          //console.log('profile  pic small');
          // console.log(result.get("user").get("profilePictureSmall").url());
        } else {
            this.state.userImage ="/images/default_userpic0.png";
        }

        
        this.state.caption = result.get("caption");
        this.state.created_at = result.get("createdAt");
        this.state.city = result.get("user").get("city");

        var likeCount = result.get("likeCountNew");
        //var likeCount1 = result.get("likeCountNew");
        var saveCount = result.get("saveCount");
        var commentCount = result.get("commentcount");
        var imprCount = result.get("impr");
        
        this.state.title = result.get("title");
        this.state.url = result.get("url");
        this.state.collabUser = result.get("collabUser");
        this.state.collabUsername = result.get("collabUsername");
        if (this.state.collabUser) { 
          result.get("collabUser").fetch();
        }

        if (!likeCount) likeCount = 0;
        if (!saveCount) saveCount = 0;
        if (!commentCount) commentCount = 0;
        if (!imprCount) imprCount = 1;

        this.state.likeCount = likeCount;
        
        this.state.saveCount = saveCount;
        this.state.commentCount = commentCount;
        this.state.imprCount = imprCount;
        this.state.postID = result.id;
        this.state.challengeStatus = result.get("challengeStatus");

        this.state.postLink = "/postsone/" + this.state.postID;
        this.state.recipe = result.get("recipeV2");
        this.state.product = result.get("productV2");

        if (this.props.showComments && this.state.recipe)
          this.state.recipe.fetch();

        if (this.props.showComments && this.state.product)
          this.state.product.fetch();

        if (this.props.showComments) //detail view only
        {
            this.queryForComments();
            this.props.postData.increment("impr");
            this.props.postData.save();
            this.state.loadpage='single';
            this.singlegetAllUsers();
            //imprCount++;
            //this.props.postData.set("imprcount", imprCount);
            //this.props.postData.save();
        }
        //this.popuprenderComments()
        this.updateInput = this.updateInput.bind(this);
        this.handleCommentPost = this.handleCommentPost.bind(this);
        this.handleCommentPostUpdate = this.handleCommentPostUpdate.bind(this);
        this.handleSavePost = this.handleSavePost.bind(this);
        this.handleGetSavePost = this.handleGetSavePost.bind(this);
        this.handleFollowUser = this.handleFollowUser.bind(this);
        this.handleUnFollowUser = this.handleUnFollowUser.bind(this);
        this.handleGetFollowUser = this.handleGetFollowUser.bind(this); 
        this.cancelText = this.cancelText.bind(this); 
        this.getUserProfileImage();
        this.handlePhotoLike = this.handlePhotoLike.bind(this);
        this.formatRenderComments = this.formatRenderComments.bind(this);
        this.handlePostModelOpen = this.handlePostModelOpen.bind(this);
        this.handleGetLikePost = this.handleGetLikePost.bind(this);
        this.handlePhotoUnLike = this.handlePhotoUnLike.bind(this);  
        this.handlePhotoActivityLike = this.handlePhotoActivityLike.bind(this);
        this.handleGetActivityLikePost = this.handleGetActivityLikePost.bind(this);
        this.handlePhotoActivityUnLike = this.handlePhotoActivityUnLike.bind(this);
        this.handleRemoveSavePost = this.handleRemoveSavePost.bind(this);   
        this.handleNotLoginClick = this.handleNotLoginClick.bind(this);
        this.singlePostModalClass = this.singlePostModalClass.bind(this);
        this.singlePostLikeModal = this.singlePostLikeModal.bind(this);  
        this.singlePostLikeModalClose = this.singlePostLikeModalClose.bind(this);          
        this.toggleExpand = this.toggleExpand.bind(this);       
        this.deleteCommentId = this.deleteCommentId.bind(this); 
        this.checkDeleteComment = this.checkDeleteComment.bind(this);  
        this.deletePostId = this.deletePostId.bind(this); 
        this.checkDeletePost = this.checkDeletePost.bind(this);
        this.handleGetLikeUser = this.handleGetLikeUser.bind(this);
        // this.addBodyClass = this.addBodyClass.bind(this);  
        
      }
      //  addBodyClass()
      //  {
      //     setTimeout(() => {
      //            if (!$("body").hasClass("modal-open")) {
      //              $("body").addClass("modal-open");
      //            }
      //     },500);
          
      //  }


 singlerenderUserSuggestion = (suggestion, search, highlightedDisplay) => (
    <div className="user-suggestion">
      <img src={suggestion.avatar} alt={suggestion.display} className="user-avatar" />
      <span>{highlightedDisplay}</span>
    </div>
  );
 singlegetAllUsers() {
    var query = new Parse.Query('_User');
        query.limit(999999999);
        query.include("profilePictureSmall");
        query.include("displayUsername");
        query.include("name");
        var self = this;
        query.find().then(function(result){
            let userdataresult1 = [];
            
            if(result){
                for (var i = 0; i < result.length; i++)
                   {
                  var user = result[i];
                    
                     let userimage='';
                     if(user.get("profilePictureSmall") && user.get("profilePictureSmall").url()!==undefined)
                     {
                         userimage=user.get("profilePictureSmall").url();
                     }
                     else{
                         userimage="/images/default_userpic0.png";
                     }  
                     //userdataresult1.push({'id':user.id,'display':user.get("displayName"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
                     //self.state.singleget_allusers.push({'id':user.id,'display':user.get("displayName"),'username':user.get("username"),'displayUsername':user.get("displayUsername"),'avatar':userimage,});
                     userdataresult1.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,});
                     self.state.singleget_allusers.push({'id':user.id,'display':user.get("displayUsername"),'avatar':userimage,});
                 }
                     this.state.singleget_allusers=userdataresult1;
            }else {
               // console.log("No users found");
            }
        }, function(error){
        });
       
  }

      getUserProfileImage() {
        const currentUser = Parse.User.current();
        if (currentUser) {
           let profile_picture = currentUser.get("profilePictureSmall");
           if(profile_picture)
             { 
                 this.state.currentuserImage = profile_picture.url();
             }
               this.state.currentUserId = currentUser.id;
        }
      }
      
      renderComments() {
        console.log('renderComments');
        //console.log("renderIngredients");
        //return      <span key="66"><h4> ingredType  <a onClick={() => this.handleAdd(0)} >Add</a></h4></span>;
        let buffer = [];

        if (this.state.comments && this.props.showComments) {
          for (var i = 0; i < this.state.comments.length; i++) {
            var comment = this.state.comments[i];
            let comment_activity_id="comment_"+comment.id;
            let comment_id="comnt_"+comment.id;
            this.state.singlelikeCount=comment.get("likeCount")?comment.get("likeCount"):0;
            var likesWord = "Likes";
            if (this.state.singlelikeCount == 1) likesWord = "Like";
            let comment_fromuserid= comment.get("fromUser").id;
            let comment_currentUserId= this.state.currentUserId;
            // if (ingredType != undefined)
            //console.log(comment.get('Photo').id);
            buffer.push(
              <div key={69*i} className="cmt_wrap">
                <div className='usr_img_detail'>
                  <div className='usr_img'>
                    <img src={this.getCommentProfilePic(comment)}/>                      
                  </div>
                  <div className="cmt_usr">
                    <div className='name'> 
                    {/* <a href={'/user/' + this.getUsername(comment.get("fromUser"))}>{this.getUsername(comment.get("fromUser"))}</a>*/}
                    {comment.get("fromUser").get('displayUsername')!=undefined?
                     <a href={'/user/' + comment.get("fromUser").get('displayUsername')}>{comment.get("fromUser").get('displayUsername')}</a>:""}
                     {/*<a href={'/user/' + this.state.getUsernamefetch}>{this.state.getUsernamefetch}</a>*/}
                      <span>{time_ago(comment.get("createdAt"))}</span>
                    </div>
                    <div className="action cta_btn">
                      <div className="btn-wrp btn-group more_action three-dot">
                        <button type="button" id="comment_dropdownlist" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <img src="/images/dot_action.svg" alt="More Option"/>
                        </button>
                        <div className="dropdown-menu dropdown-menu-right">
                          {/*<a href="javascript:void(0);"  className="dropdown-item danger" type="button">Delete</a>*/}
                          {comment_fromuserid===comment_currentUserId?<a href="javascript:void(0);"   className="dropdown-item danger" type="button" data-toggle="modal" data-target="#deleteCommentCloseModal"   onClick={(e) => this.deleteCommentId(comment_id)}   id="close_deleteCommentwithdiscard" aria-label="Modal">Delete</a> :<a href="javascript:void(0);"  className="dropdown-item danger" type="button">Report</a> }
                          <a href="javascript:void(0);" className="dropdown-item" type="button">Cancel</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cmt_box">
                    <div className="cmt_cnt" id={comment_id}>{this.formatRenderComment(comment.get("content"),comment_id,comment.id)}</div>
                    <div className='comment_mn '>
                      <div className="post_action d-flex flex-column flex-wrap align-items-start w-100">
                        <div className='action_grp'>
                          {/* <a href = "../appstore" className='liked'>
                            <img className="default" src="../images/like.svg"/>
                            <img className="active" src="../images/like-fill.svg"/>
                          </a>*/}
                        
                          <a  href = "javascript:void(0);"  className='liked_activity'  id={comment_activity_id} >
                            <img data-id={comment.id} id={comment_activity_id}  onClick={(e) => {this.handlePhotoActivityLike(e);}}  className="activitydefault" src="../images/cmt-like.svg"/>
                            <img data-id={comment.id} id={comment_activity_id}  onClick={(e) => {this.handlePhotoActivityUnLike(e);}}  className="activityactive"  style={{ display: "none" }}   src="../images/like-fill.svg"/>
                              {/* <button  data-id={comment.id} id={comment_activity_id}   onClick={this.handleGetActivityLikePost(comment.id)} >Cancel</button>*/}
                            {this.handleGetActivityLikePost(comment.id)}
                          </a>
                        </div>
                        <div className='comment_count'>
                          <span className="like box">
                            <a href="#">
                            {/* 6 Likes*/}{/*0 likes*/} {/*{comment.get("likeCount")?comment.get("likeCount"):0}*/} {this.state.singlelikeCount} {likesWord} 
                            </a>
                          </span>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            );
          }
        }
        return ( <div className='cmt_wrap_list'>
                {buffer}
                </div>
        );
      }
      handleUnFollowUser = (touser_id) => {
        const currentUser = Parse.User.current();
        if (currentUser) {         
          const currentUser_id = currentUser.id;
          var checksavequery = new Parse.Query('Activity');  
            checksavequery.equalTo('type', 'follow'); 
            checksavequery.equalTo('toUser', "_User$"+touser_id.id);
            checksavequery.equalTo('fromUser',"_User$"+currentUser_id);
            checksavequery.find().then(function(resultAct){
                if(resultAct)
                {  
                     let activityresult=resultAct[0];
                     try {
                        activityresult.destroy();
                          setTimeout(() => {
                         $('a.unfollowpost_link#follow_'+touser_id.id).attr("style", "display: none");
                         $('a.followpost_link#follow_'+touser_id.id).attr("style", "display: block");
                         },500);
                      } catch (error) {
                        console.error('Error deleting activity:', error);
                      }   
                 }
             })
               setTimeout(() => {
                   this.handleGetFollowUser(touser_id);
               },1000);
        }else
        {
            //window.alert('You need to login for follow user.');
            return false;
        }

      } 
      handleFollowUser = (touser_id) => {
        const currentUser = Parse.User.current();
        if (currentUser) {
            const currentUser_id = currentUser.id;  
            var Activity = Parse.Object.extend("Activity");
            var activity = new Activity();
            activity.set('fromUser', currentUser);
            activity.set('toUser', touser_id);              
            activity.set('type', 'follow'); 
            activity.save().then((savedFile) => {
                   setTimeout(() => {
                       //$('a.followpost_link#follow_'+touser_id.id).attr("style", "display: none");
                       //$('a.unfollowpost_link#follow_'+touser_id.id).attr("style", "display: block");
                       $('a.followpost_link#follow_'+touser_id.id).attr("style", "display: none");
                       this.handleGetFollowUser(touser_id);
                   },500);
            }).catch((error) => {
            });
        }else
        {
         
          $('#login_popup_btn').trigger('click');
          // $('#kitchenQrModal_btn').trigger('click');  
          return false;
        }
      }
      handleGetFollowUser = (touser_id) => {
        const currentUser = Parse.User.current();
        if (currentUser) {
          const currentUser_id = currentUser.id;
          var resultSavedid=0;
          var checksavequery = new Parse.Query('Activity');  
            checksavequery.equalTo('type', 'follow'); 
            checksavequery.equalTo('toUser', "_User$"+touser_id.id);
            checksavequery.equalTo('fromUser',"_User$"+currentUser_id);
            checksavequery.find().then(function(resultSave){
                if(resultSave)
                {  
                      let resultSaved=resultSave[0];
                      resultSavedid= resultSaved.id;
                      $('a.followpost_link#follow_'+touser_id.id).attr("style", "display: none");
                      /*let resultSaved=resultSave[0];
                      resultSavedid= resultSaved.id;
                      $('a.followpost_link#follow_'+touser_id.id).attr("style", "display: none");
                      $('a.unfollowpost_link#follow_'+touser_id.id).attr("style", "display: block");*/
                }else
                {
                      /*$('a.followpost_link#follow_'+touser_id.id).attr("style", "display: block");
                      $('a.unfollowpost_link#follow_'+touser_id.id).attr("style", "display: none");*/
                }
            })
        }
      }
      handleGetSavePost = (post_id,page) => {
        var posts_id='';
        if(page==='popup')
        {
           posts_id=$('#popup_post_id').val();
           post_id=posts_id;
        }
        var check_value=0;
        const currentUser = Parse.User.current();
        if (currentUser) {
          const currentUser_id = currentUser.id;        
          var resultSavedid=0;
          var checksavequery = new Parse.Query('Save');  
          checksavequery.equalTo('photo', "Photo$"+post_id);
          checksavequery.equalTo('fromUser',"_User$"+currentUser_id);
          checksavequery.find().then(function(resultSave){
              if(resultSave)
              {             
                  let resultSaved=resultSave[0];
                  resultSavedid= resultSaved.id;
                  let photo_id= resultSaved.get('photo').id;
                  if(resultSavedid)
                  {  
                      //$('.active#save_'+post_id).attr("style", "display: block"); 
                      //$('.default#save_'+post_id).attr("style", "display: none"); 
                      //$('a.savepost_link#save_'+post_id).attr("style", "display: none");  
                      $('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style", "display: none"); 
                      $('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style", "display: block");
                      if(posts_id)
                      {
                          $('.post_save1 a.savepost_link1 .savedefault1#save_'+posts_id).attr("style", "display: none"); 
                          $('.post_save1 a.savepost_link1 .saveactive1#save_'+posts_id).attr("style", "display: block");
                      }

                     
                  }  
              }
          })
        }
      }

      handleRemoveSavePost= (post_id,page) => {
        var posts_id='';
        if(page==='popup')
        {
           posts_id=$('#popup_post_id').val();
           post_id=posts_id;
        }
        let getLoggedinUsername=localStorage.getItem('username');
        if(!getLoggedinUsername) {
            //window.alert('You need to login to save post.');
            return false;
        }else {
          var query = new Parse.Query('Photo');  
          query.equalTo('objectId', post_id);
          query.find().then(function(photo){
                    if(photo)
                    {
                         let photo_ob=photo[0];
                         var photoid= photo_ob.id;
                         var saveCount= photo_ob.get('saveCount');
                         if(saveCount==undefined ||  saveCount < 0)
                         { 
                             saveCount=0;
                         }else
                         {
                            saveCount=saveCount-1;
                         }
                          
                            photo_ob.set("saveCount", saveCount);         
                            photo_ob.save();
                            let currentUser = Parse.User.current(); 
                            var checklikequery = new Parse.Query('Save');  
                            checklikequery.equalTo('photo', photo_ob); 
                            checklikequery.equalTo('fromUser', currentUser);  
                            checklikequery.first()
                              .then((object) => {
                                if (object) {
                                  return object.destroy();
                                } else {
                                     $('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style", "display: block"); 
                                     $('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style", "display: none");

                                     $('.post_save1 a.savepost_link1 .savedefault1#save_'+post_id).attr("style", "display: block"); 
                                     $('.post_save1 a.savepost_link1 .saveactive1#save_'+post_id).attr("style", "display: none");
                                }
                              })
                              .then((deletedObject) => {
                                     $('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style", "display: block"); 
                                     $('.post_save a.savepost_link .saveactive#save_'+post_id).attr("style", "display: none");

                                     $('.post_save1 a.savepost_link1 .savedefault1#save_'+post_id).attr("style", "display: block"); 
                                     $('.post_save1 a.savepost_link1 .saveactive1#save_'+post_id).attr("style", "display: none");
                              })
                              .catch((error) => {
                                console.error('Error deleting record:', error);
                              });      
                    } else {
                        //console.log("No post found");
                    }

                }, function(error){
                     //   console.error("Error loading post Error: " + error);
                        //promise.error(error);
                });
                     setTimeout(() => {
                          var self = this;
                          self.handleGetSavePost(post_id,page);
                     },1000);
        }
      }
      handleSavePost = (post_id,page) => {

        var posts_id='';
        if(page==='popup')
        {
           posts_id=$('#popup_post_id').val();
           post_id=posts_id;
        }
        let getLoggedinUsername=localStorage.getItem('username');
        if(!getLoggedinUsername)
        {
            //window.alert('You need to login to save post.');
            return false;
        }else
        {
        var query = new Parse.Query('Photo');  
        query.equalTo('objectId', post_id);
        query.find().then(function(photo){
            //$('.post_save a.savepost_link .savedefault#save_'+post_id).attr("style", "display: none"); 
                    if(photo)
                    {
                         let photo_ob=photo[0];
                         var photoid= photo_ob.id;
                         var saveCount= photo_ob.get('saveCount');
                         if(saveCount==undefined)
                         {
                             saveCount=1;
                         }else
                         {
                            saveCount=saveCount+1;
                         }
                          
                            photo_ob.set("saveCount", saveCount);                          
                            photo_ob.save();
                            var Save = Parse.Object.extend("Save");
                            var save = new Save();
                            let currentUser = Parse.User.current(); 
                            let currentUser_id=currentUser.id; 
                            save.set('fromUser', currentUser);
                            save.set('photo', photo_ob);
                            save.set("_wperm", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                             save.set("_rperm", {
                              "*": {
                               "read": true,
                                "write": true 
                              }
                            });
                             save.set("_acl", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                             var acl = new Parse.ACL();
                            acl.setPublicReadAccess(true);
                            acl.setPublicWriteAccess(true);
                            //acl.setWriteAccess(photo_ob.get('user'), true); 
                            acl.setWriteAccess(currentUser, true); 
                            acl.setReadAccess(currentUser, true); 
                            save.setACL(acl);
                            save.save().then((savedFile) => {
                                 //  window.alert('You Saved post.');
                                 //  window.location.href = "/";
                            }).catch((error) => {
                            });                       
                    } else {
                        //console.log("No post found");
                    }


                }, function(error){
                     //   console.error("Error loading post Error: " + error);
                        //promise.error(error);
                });
         setTimeout(() => {
                          var self = this;
                          self.handleGetSavePost(post_id,page);
                          if(posts_id)
                          {
                            self.handleGetSavePost(post_id,'popup');
                          }
                     },1500);
        }
      }
      handleGetLikeUser = (post_id) => {
          var like = new Parse.Query('Like');
          var self = this; 
          like.equalTo('photo', 'Photo$'+post_id);

          like.find().then(function(result){
              if(result)
              {              
                self.setState({likeuserlist:result}); 
              }              
          })
      }
        renderlikeuserlist()
    {
       
       let userlikeusername = [];
       let othertext='';
       if (this.state.likeuserlist)
        {
          
            var rows = this.state.likeuserlist.length;
            var other=0;
            for (var i = 0; i < rows; i++)
            {  
               var likeuser = this.state.likeuserlist[i]; 
               if(rows>2)
                 { 
                     other=rows-1;  
                 }  
              if(i==0)
                  {
                      if (likeuser.get('fromUser') && likeuser.get('fromUser').id!==undefined){
                    userlikeusername.push(<span  key={69*i}>
                              {likeuser.get('fromUser').get("displayUsername")}
                            </span>); 
                  }
                 }

            }
             if(rows>2 && other)
            {
                if(other==1)
                {
                      othertext=' and '+other+' other ';
                }else{
                      othertext=' and '+other+' others ';
                }                
            }
             return (
                <div className="user_people">
                    {userlikeusername!=''?<label>Liked by  {userlikeusername} {othertext?<label> {othertext}</label>:""}</label> :''}
                   
                </div>
            );
        }

    }  

      handleGetLikePost = (post_id) => {
        var check_value=0;
        const currentUser = Parse.User.current();
        if (currentUser) {
            const currentUser_id = currentUser.id;        
            var resultLikedid=0;
            var checklikequery = new Parse.Query('Like');  
            checklikequery.equalTo('photo', "Photo$"+post_id);
            //checklikequery.equalTo('fromUser',"_User$"+currentUser_id);
            checklikequery.equalTo('fromUser', currentUser);  
            //checklikequery.notContainedIn("activity");   
            checklikequery.doesNotExist("activity");
            checklikequery.find().then(function(resultLike){
                if(resultLike)
                {             
                    let resultLiked=resultLike[0];
                    resultLikedid= resultLiked.id;
                    if(resultLikedid!==undefined)
                    {  
                       $('a.liked .active#like_'+post_id).attr("style", "display: block"); 
                       $('a.liked .default#like_'+post_id).attr("style", "display: none");

                       $('a.liked1 .active1#like_'+post_id).attr("style", "display: block"); 
                       $('a.liked1 .default1#like_'+post_id).attr("style", "display: none");
                    }
                    if(resultLikedid===undefined){                      
                       $('a.liked .active#like_'+post_id).attr("style", "display: none"); 
                       $('a.liked .default#like_'+post_id).attr("style", "display: block");

                       $('a.liked1 .active1#like_'+post_id).attr("style", "display: none"); 
                       $('a.liked1 .default1#like_'+post_id).attr("style", "display: block"); 
                    }                              
                }
            })
      }
      }

      handlePhotoUnLike= (post_id,page) => {
        var posts_id='';
        if(page==='popup')
        {
           post_id=$('#popup_post_id').val();
           posts_id=$('#popup_post_id').val();
        }
        let getLoggedinUsername=localStorage.getItem('username');
        if(!getLoggedinUsername)
        {
            $('#kitchenQrModal_btn').trigger('click');    
            return false;
        }else
        {
         //$('a.liked .active#like_'+post_id).attr("style", "display: none");
         const currentUser = Parse.User.current();
         if (currentUser) { 
         var query = new Parse.Query('Photo');  
            query.equalTo('objectId', post_id);
            //query.equalTo('user', currentUser);
            var self = this;  
            query.find().then(function(photo){
                    if(photo)
                    {
                         let photo_ob=photo[0];
                         var photoid= photo_ob.id;
                         var likeCount= photo_ob.get('likeCountNew');
                         if(likeCount==undefined || likeCount==1)
                         {
                             likeCount=0;
                         }else
                         {
                            likeCount=likeCount-1;
                         }                          
                            photo_ob.set("likeCountNew", likeCount);  
                            photo_ob.save();  
                            var checklikequery = new Parse.Query('Like');  
                            checklikequery.equalTo('photo', photo_ob); 
                            checklikequery.equalTo('fromUser', currentUser);  
                            checklikequery.first()
                              .then((object) => {
                                if (object) {
                                  return object.destroy();
                                   $('a.liked .active#like_'+post_id).attr("style", "display: none"); 
                                  $('a.liked .default#like_'+post_id).attr("style", "display: block");
                                  if(posts_id)
                                  {
                                     $('a.liked1 .active1#like_'+posts_id).attr("style", "display: none"); 
                                      $('a.liked1 .default1#like_'+posts_id).attr("style", "display: block");
                                  }
                                 
                                } else {
                                    $('a.liked .active#like_'+post_id).attr("style", "display: none"); 
                                    $('a.liked .default#like_'+post_id).attr("style", "display: block");
                                    if(posts_id)
                                    {
                                      $('a.liked1 .active1#like_'+posts_id).attr("style", "display: none"); 
                                      $('a.liked1 .default1#like_'+posts_id).attr("style", "display: block");
                                  }
                                }
                              })
                              .then((deletedObject) => {
                                  self.setState({likeCount:likeCount});  
                                  //self.setState({likeCount1:likeCount}); 
                                  //$('#home_fetch').trigger('click');
                                  $('a.liked .active#like_'+post_id).attr("style", "display: none"); 
                                  $('a.liked .default#like_'+post_id).attr("style", "display: block");
                                   if(posts_id)
                                  {
                                  $('a.liked1 .active1#like_'+posts_id).attr("style", "display: none"); 
                                  $('a.liked1 .default1#like_'+posts_id).attr("style", "display: block");
                                  $('#popup_post_id').val(posts_id);                                  
                                  var likesWord = "Likes";
                                  if (likeCountNew == 1) likesWord = "Like";
                                  $('#like_counts_'+posts_id).html(likeCount);
                                  if(likeCount==1)
                                  {
                                    likesWord = "Like";
                                    $('#like_words_'+posts_id).html(likesWord);
                                  }
                                  }
                                  let likeCountNew=likeCount;
                              $('#like_count_new').html(likeCountNew+' '+likesWord); 
                               
                              })
                              .catch((error) => {
                                console.error('Error deleting record:', error);
                              });  
                              $('#home_fetch').trigger('click');      
                                           
              }
          });
              setTimeout(() => {
                            var self = this;
                           self.handleGetLikeUser(posts_id);
                      },1000);
      }
        }
      }
      handleGetActivityLikePost = (comment_id) => {
         var check_value=0;
         let post_id=this.state.postID;
         const currentUser = Parse.User.current();
         if (currentUser) {
            const currentUser_id = currentUser.id;        
            var resultLikedid=0;
            var checklikequery = new Parse.Query('Like');  
            checklikequery.include("activity");
            checklikequery.equalTo('photo', "Photo$"+post_id);
            checklikequery.equalTo('activity',"Activity$"+comment_id);
            checklikequery.equalTo('fromUser', currentUser);    
           
            checklikequery.find().then(function(resultLike){
                if(resultLike)
                {             
                    let resultLiked=resultLike[0];
                    resultLikedid= resultLiked.id;                    
                    if(resultLikedid!==undefined)
                    {  
                       $('.comment_list_mn  a.liked_activity .activitydefault#comment_'+comment_id).attr("style", "display: none");
                       $('.comment_list_mn a.liked_activity .activityactive#comment_'+comment_id).attr("style", "display: block"); 
                    }   
                    if(resultLikedid===undefined){  
                       $('.comment_list_mn a.liked_activity .activitydefault#comment_'+comment_id).attr("style", "display: block");
                       $('.comment_list_mn a.liked_activity .activityactive#comment_'+comment_id).attr("style", "display: none"); 
                    }                            
                }
            })
        }
      }
      handlePhotoActivityUnLike = (e) => {
        let getLoggedinUsername=localStorage.getItem('username');
              if(!getLoggedinUsername)
              {
                  $('#kitchenQrModal_btn').trigger('click');    
                  return false;
              }else
              {
                  let  post_id=e.target.id;
                  let datapost_id=e.target.dataset.id;
                  $('.comment_list_mn a.liked_activity .activityactive#comment_'+datapost_id).attr("style", "display: none");
                  var query = new Parse.Query('Activity');  
                  query.equalTo('objectId', datapost_id);
                  var self = this;
                  query.find().then(function(activity){
                          if(activity)
                          {
                              let activity_ob=activity[0];
                              let likeCount;
                              if (activity_ob) {
                                likeCount = activity_ob.get('likeCount');
                              } else {
                                likeCount =0;
                              }                        
                              if(likeCount==undefined || likeCount < 0)
                              {
                                  likeCount=0;
                              }else
                              {
                                  likeCount=likeCount-1;
                              }
                              let photo_ob= activity_ob.get('photo');
                              activity_ob.set("likeCount", likeCount);
                              activity_ob.save();
                              //like 
                                  let currentUser = Parse.User.current(); 
                                  let currentUser_id=currentUser.id;                          
                                  var checklikequery = new Parse.Query('Like');  
                                  checklikequery.equalTo('photo', photo_ob); 
                                  checklikequery.equalTo('fromUser', currentUser);  
                                  checklikequery.equalTo('activity', activity_ob);
                                  checklikequery.first()
                                    .then((object) => {
                                      if (object) {
                                        return object.destroy();
                                      } else {
                                          $('.comment_list_mn a.liked_activity .activitydefault#comment_'+datapost_id).attr("style", "display: block");
                                          $('.comment_list_mn a.liked_activity .activityactive#comment_'+datapost_id).attr("style", "display: none"); 
                                      }
                                    })
                                    .then((deletedObject) => {
                                        //self.setState({likeCount:likeCount});  
                                        //$('#home_fetch').trigger('click');
                                        self.setState({singlelikeCount:likeCount}); 
                                      $('.comment_list_mn a.liked_activity .activityactive#comment_'+datapost_id).attr("style", "display: none"); 
                                      $('.comment_list_mn a.liked_activity .activitydefault#comment_'+datapost_id).attr("style", "display: block");
                                      
                                    })
                                    .catch((error) => {
                                      console.error('Error deleting record:', error);
                                    });  
                              //like  
                          }
                      })
                  setTimeout(() => {
                            var self = this;
                            self.handleGetActivityLikePost(datapost_id);
                      },1000);
              }
      }
      handlePhotoActivityLike = (e) => {
        let getLoggedinUsername=localStorage.getItem('username');
        if(!getLoggedinUsername)
        {
            $('#kitchenQrModal_btn').trigger('click');    
            return false;
        }else
        {
            let  post_id=e.target.id;
            let datapost_id=e.target.dataset.id;
            $('.comment_list_mn a.liked_activity .activitydefault#comment_'+datapost_id).attr("style", "display: none");
            var query = new Parse.Query('Activity');  
            query.equalTo('objectId', datapost_id);
            var self = this;
            query.find().then(function(activity){
                    if(activity)
                    {
                        let activity_ob=activity[0];
                        let likeCount;
                        if (activity_ob) {
                           likeCount = activity_ob.get('likeCount');
                        } else {
                           likeCount =0;
                        }                        
                         if(likeCount==undefined)
                         {
                             likeCount=1;
                         }else
                         {
                            likeCount=likeCount+1;
                         }
                         let photo_ob= activity_ob.get('photo');
                         activity_ob.set("likeCount", likeCount); 
                         activity_ob.save();
                         //like 
                            var Like = Parse.Object.extend("Like");
                            var like = new Like();
                            let currentUser = Parse.User.current(); 
                            let currentUser_id=currentUser.id; 
                            like.set('fromUser', currentUser);
                            like.set('photo', photo_ob);
                            like.set('activity', activity_ob);
                            like.set("_wperm", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                             like.set("_rperm", {
                              "*": {
                               "read": true,
                                "write": true 
                              }
                            });
                             like.set("_acl", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                            var acl = new Parse.ACL();
                            acl.setPublicReadAccess(true);
                            acl.setPublicWriteAccess(true);
                            acl.setWriteAccess(currentUser, true); 
                            acl.setReadAccess(currentUser, true); 
                            like.setACL(acl);
                            const fromUserThumb = currentUser.get('profilePictureSmall');
                            if(fromUserThumb!=undefined)
                             { 
                                  like.set('fromUserThumb', fromUserThumb);
                             }
                             like.save().then((likeActivitySaved) => {                     
                                    self.setState({singlelikeCount:likeCount}); 
                             }).catch((error) => {
                            });
                         //like  
                     }
                 })
            setTimeout(() => {
                      var self = this;
                      self.handleGetActivityLikePost(datapost_id);
                 },1000);
        }
      }

      
      handlePhotoLike = (post_id,page) => {
        var posts_id='';
        if(page==='popup')
        {
          post_id=$('#popup_post_id').val();
          posts_id=$('#popup_post_id').val();
        }

        let getLoggedinUsername=localStorage.getItem('username');
        if(!getLoggedinUsername)
        {
            $('#kitchenQrModal_btn').trigger('click');    
            return false;
        }else
        { 
            //$('a.liked .default#like_'+post_id).attr("style", "display: none");
            var query = new Parse.Query('Photo');  
            query.equalTo('objectId', post_id);
             var self = this;
            query.find().then(function(photo){
                    if(photo)
                    {
                         let photo_ob=photo[0];
                         var photoid= photo_ob.id;
                         var likeCount= photo_ob.get('likeCountNew');
                         if(likeCount==undefined)
                         {
                             likeCount=1;
                         }else
                         {
                            likeCount=likeCount+1;
                         }                         
                            photo_ob.set("likeCountNew", likeCount);      
                            photo_ob.save();
                            var Like = Parse.Object.extend("Like");
                            var like = new Like();
                            let currentUser = Parse.User.current(); 
                            let currentUser_id=currentUser.id; 
                            like.set('fromUser', currentUser);
                            like.set('photo', photo_ob);
                            like.set("_wperm", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                             like.set("_rperm", {
                              "*": {
                               "read": true,
                                "write": true 
                              }
                            });
                             like.set("_acl", {
                              "*": {
                                "read": true,
                                "write": true 
                              }
                            });
                            var acl = new Parse.ACL();
                            acl.setPublicReadAccess(true);
                            acl.setPublicWriteAccess(true);
                            acl.setWriteAccess(currentUser, true); 
                            acl.setReadAccess(currentUser, true); 
                            like.setACL(acl);
                            const fromUserThumb = currentUser.get('profilePictureSmall');
                            if(fromUserThumb!=undefined)
                             { 
                                  like.set('fromUserThumb', fromUserThumb);
                             }   
                              //this.state.likeCount=likeCount;                

                            like.save().then((likeSaved) => {
                                    self.setState({likeCount:likeCount}); 
                                   // self.setState({likeCount1:likeCount}); 
                                   //window.alert('You Like post.');
                                
                                   /*if(page=='single')
                                   {
                                      window.location.href = "/posts/"+post_id;
                                   }else
                                   {
                                      window.location.href = "/";
                                   }*/
                                    $('a.liked .default#like_'+post_id).attr("style", "display: none");
                                    $('a.liked .active#like_'+post_id).attr("style", "display: block"); 
                                    if(posts_id)
                                    {
                                       $('a.liked1 .default1#like_'+posts_id).attr("style", "display: none");
                                       $('a.liked1 .active1#like_'+posts_id).attr("style", "display: block");
                                       $('#popup_post_id').val(posts_id);
                                       $('#like_counts_'+posts_id).html(likeCount);

                                    var likesWord = "Likes";
                                    if (likeCountNew == 1) likesWord = "Like";
                                        if(likeCount==1)
                                        {
                                          likesWord = "Like";
                                          $('#like_words_'+posts_id).html(likesWord);
                                        }                                       
                                    }
                                    let likeCountNew=likeCount;
                                    $('#like_count_new').html(likeCountNew+' '+likesWord);
                                    $('#home_fetch').trigger('click');
                                  // this.handleGetLikePost(post_id);
                                   
                            }).catch((error) => {
                            });  
                                                                         
                    } else {
                    }
                }, function(error){
                });
             setTimeout(() => {
                          var self = this;
                          self.handleGetLikePost(post_id);
                          self.handleGetLikeUser(post_id);
                          if(posts_id)
                          {
                             //self.handleGetLikePost(posts_id);
                             //self.queryForSinglepost(); 

                          }
                         
                     },1500);
        }
      }
  
      updateInput(event){
         this.setState({singlementioned: event.target.value});
         this.setState({postcomment : event.target.value});
      }
      
      postHeaderText() {
        var headerText = ""; //disable timestamp 5/29/19 //time_ago(this.state.created_at);

        if (this.state.city)
        {
            //var city = this.state.postData.get("city");

            headerText += this.state.city;

        }
        /*
        if (this.state.product)
        {
            headerText += " * " + "PRODUCT";
        }
        if (this.state.recipe)
        {
            headerText += " * " + "RECIPE";
        }*/
        return headerText;
      }
      
      queryForComments() {
        console.log('queryForComments');
        var query = new Parse.Query('Activity');
        
        query.equalTo("photo", this.props.postData);
        query.equalTo("type", "comment");

        query.include("fromUser");
        query.include("image");
        query.include("content");
        query.include("_created_at");
        query.include("createdAt");
        //query.ascending("_created_at");
        query.descending("_created_at");

        var self = this;

        query.find().then(function(result){
            if(result){
                self.setState({comments: result});

                //promise.resolve(result);
            } else {
               // console.log("No comments found");
               // promise.resolve(null);
            }
        }, function(error){
                //console.error("Error loading comments Error: " + error);
                //promise.error(error);
        });
      }
      queryForCommentspopup(photo_ob) {
        //console.log('queryForCommentspopup');
        var query = new Parse.Query('Activity');
        
        query.equalTo("photo", photo_ob);
        query.equalTo("type", "comment");

        query.include("fromUser");
        query.include("image");
        query.include("content");
        query.include("_created_at");
        query.include("createdAt");
        //query.ascending("_created_at");
        query.descending("_created_at");

        var self = this;

        query.find().then(function(result){
            if(result){
                self.setState({comments_data: result});
            } else {
            }
        }, function(error){
        });
      }

      //handleCommentPostUpdate = function(e){
      handleCommentPostUpdate = () => {       
        let photo_post_id=this.state.postID;
        var query = new Parse.Query('Activity');
        
        query.equalTo("photo", 'Photo$'+photo_post_id);
        query.equalTo("type", "comment");

        query.include("fromUser");
        query.include("image");
        query.include("content");
        query.include("_created_at");
        query.include("createdAt");
       // query.ascending("_created_at");
         query.descending("_created_at");

        var self = this;

        query.find().then(function(result){
            if(result){
                self.setState({comments: result});
                self.setState({commentCount:result.length});
            } else {
            }
        }, function(error){
        });
      }
   

      handleCommentPost = function(e){
        
        var Photo = Parse.Object.extend("Photo");
        var query = new Parse.Query(Photo);
        let photo_post_id=this.state.postID;
        var postcomment=this.state.postcomment;
        if(postcomment) {
          query.include("user");
          query.include("image");
          query.include("thumbnail");
          query.include("likeCountNew");
          query.include("saveCount");
          query.include("commentcount");
          query.include("_created_at");
          query.include("createdAt");
          query.exists("user");
          query.descending("createdAt");

          query.find({
            success: function(results) {
              if (results.length > 0) {
                results.forEach(function(photo) {                
                  if( photo.id===photo_post_id)
                  {
                      var Activity = Parse.Object.extend("Activity");
                      var activity = new Activity();
                      let currentUser = Parse.User.current(); 
                      activity.set('fromUser', currentUser);
                      activity.set('toUser', photo.get("user"));
                      activity.set('content', postcomment);                 
                      activity.set('type', 'comment');                    
                      activity.set('photo', photo);    
                      activity.set('likeCount', 0);  
                      
                      let currentUser_id=currentUser.id;                
                    
                      //this.state.commentCount ="5";
                      // $('#handleCommentPostupdate').trigger('click');
                      
                      activity.set("_wperm", {
                                "*": {
                                  "write": true // Allow write access to all users
                                }
                              });

                              // Set the read permission (_rperm) for the Activity object
                              activity.set("_rperm", {
                                "*": {
                                  "read": true // Allow read access to all users
                                }
                              });

                              // Set the ACL (_acl) for the Activity object
                              activity.set("_acl", {
                                "*": {
                                  "read": true, // Allow read access to all users
                                  "write": true // Allow write access to all users
                                }
                              });
                          var acl = new Parse.ACL();
                          acl.setPublicReadAccess(true);
                          acl.setPublicWriteAccess(true);
                          acl.setWriteAccess(photo.get('user'), true); 
                          acl.setWriteAccess(currentUser_id, true); 
                          acl.setReadAccess(currentUser_id, true); 
                          
                          activity.setACL(acl);
                          var self = this;
                      try {
                          activity.save().then((savedActivity) => {
                            const activityId = savedActivity.id;
                            setTimeout(() => {
                                $('a.liked_activity .activityactive#comment_'+activityId).attr("style", "display: none"); 
                                $('a.liked_activity .activitydefault#comment_'+activityId).attr("style", "display: block"); 
                            },1000);                         
                          }).catch((error) => {
                            //console.error('Error saving activity:', error);
                          });
                          $(".comment_box").val('');
                          $("#comment_box").val('');
                          var updated_photo_id=photo.get('id');
                          const Photo_single = Parse.Object.extend("Photo");
                          const Photoquery = new Parse.Query(Photo_single);
                          const photoId = photo.id;
                          Photoquery.get(photoId)
                            .then(photo => {
                              var commentcount_val=parseInt(photo.get('commentcount'));
                              if(isNaN(commentcount_val))
                              {
                                  commentcount_val=0;
                              }                             
                              var updated_comment_count=commentcount_val+1;
                              photo.set("commentcount", updated_comment_count.toString());
                              photo.save();

                            
                            })
                            .catch(error => {
                            //  console.error("Error retrieving photo:", error);
                            });
                      } catch (error) {
                          //console.log(error.message);
                      }
                  }
                });

              } else {
                //console.log("No photos found.");
              }
              
            },
            error: function(error) {
             // console.error("Error fetching photos: " + error.code + " " + error.message);
            }
          });
         
          setTimeout(() => {
              var self = this;
              self.handleCommentPostUpdate();
              this.state.postcomment='';
              this.state.singlementioned='';
          },1000);
        }
        //photo.id = "photo_object_id";
        // console.log(photo.id);
        var self = this;
        let post_id=this.state.postID;
        if(postcomment!='') {

        } else {
          self.setState({blank_comment_message:"Your message box is empty. Please write a message to continue."});
          // window.alert('Please write some comment first!');
        }
        setTimeout(() => {
          self.setState({blank_comment_message:null}); 
        }, 3000);
      }

      cancelText(event){
        var postcomment=this.state.postcomment;       
        setTimeout(() => {             
            this.state.postcomment='';
            $(".comment_box").val('');
        },500);  
      }
      toggleExpand(commentId) {
        this.setState((prevState) => ({
            isExpanded: !prevState.isExpanded
        }));
         this.setState((prevStates) => ({
            expandedCommentId: commentId
        }));
      }
      deleteCommentId(commentId) {
        var commentIds= commentId.split('comnt_');
        let commenUpdatedId=commentIds[1];
        $('#delete_comment_id').val(commenUpdatedId);
      }
      checkDeleteComment() {
        let delete_comment_id= $('#delete_comment_id').val();    
        const currentUser = Parse.User.current();

        if(currentUser) {
          var query_activity = new Parse.Query('Activity');  
          query_activity.equalTo('objectId', delete_comment_id);
          query_activity.equalTo('fromUser', currentUser);
          query_activity.first().then((object) => {

          if (object) {
              var photo_obj_id= object.get('photo').id;         
              /*photo*/
              var query = new Parse.Query('Photo');  
              query.equalTo('objectId', photo_obj_id);
              query.find().then(function(photo){
              if(photo)
              {
                  let photo_ob=photo[0];
                  var photoid= photo_ob.id;
                  var commentcount= photo_ob.get('commentcount');
                  if(commentcount==undefined || commentcount===1 || commentcount < 0)
                  {
                      commentcount=0;
                  }else
                  {
                      commentcount=commentcount-1;
                  } 
                    photo_ob.set("commentcount", commentcount.toString()); 
                    photo_ob.save();
                  }
              });
              /*photo*/
              return object.destroy();
          } 

          }).then((deletedObject) => {
            setTimeout(() => {
              var self = this;
              self.handleCommentPostUpdate();
            },500);
          }).catch((error) => {
            console.error('Error deleting record:', error);
          }); 
        }   
      }
      deletePostId(post_id) {
        $('#delete_post_id').val(post_id);
      }
      checkDeletePost(page) {
        let delete_post_id= $('#delete_post_id').val();  
        const currentUser = Parse.User.current();
        if(currentUser) {
          var query = new Parse.Query('Photo');  
          query.equalTo('objectId', delete_post_id);
          var self = this;
          query.find().then(function(photo){
            if(photo) {
                let photo_ob=photo[0];
                //like
                var checklikequery = new Parse.Query('Like');  
                checklikequery.equalTo('photo', "Photo$"+delete_post_id);
                checklikequery.find().then((object) => {
                    if (object) {
                        //return object.destroy();
                        for (const objects of object) {
                              objects.destroy();
                        }
                    }
                  })
                  .then((deletedObject) => {

                  })
                  .catch((error) => {
                    console.error('Error deleting record:', error);
                  }); 
                //like

                //activity
                var checkActivityquery = new Parse.Query('Activity');  
                checkActivityquery.equalTo('photo', "Photo$"+delete_post_id);
                checkActivityquery.find().then((object) => {
                    if (object) {
                          for (const objects of object) {
                              objects.destroy();
                        }
                        //return object.destroy();
                    }
                  })
                  .then((deletedObject) => {

                  })
                  .catch((error) => {
                    console.error('Error deleting record:', error);
                  }); 
                //activity

                //save
                var checkSavequery = new Parse.Query('Save');  
                checkSavequery.equalTo('photo', "Photo$"+delete_post_id);
                checkSavequery.find().then((object) => {
                    if (object) {
                        //return object.destroy();  
                        for (const objects of object) {
                              objects.destroy();
                        }                       
                    }
                  })
                  .then((deletedObject) => {

                  })
                  .catch((error) => {
                    console.error('Error deleting record:', error);
                  }); 
                //activity 
                  if(photo_ob)
                  {
                      photo_ob.destroy();  
                  }
                    setTimeout(() => {
                      window.location.href = "/";
                    },500);
                  /*if(page=='single')
                    {
                    console.log(page);
                      window.location.href = "/";
                    }else
                    {
                      console.log(page);
                      $('#home_fetch').trigger('click');
                    }*/                    
            }
          })
        }
      }
      formatComment(origComment) {
        if (!origComment)
          return "";

        var stringSplit = origComment.split(" ");
        var result = "";

        for(var i =0; i < stringSplit.length; i++){
            var comp = stringSplit[i];
            var firstChar = comp.charAt(0);

            if (firstChar == "#")
            {
                result += '<a href="/appstore">' + comp + '</a> ';
            }
            else if ((comp.indexOf("http://") !== -1) || (comp.indexOf("https://") !== -1))
            {
                //link
                result += '<a href="' + comp + '"">' + comp + '</a>';
            }
            else
            {
                result += comp;
            }
            result += " ";
        }
        return result;
      }
      renderComment(comment) {
        //console.log("renderIngredients");
        //return      <span key="66"><h4> ingredType  <a onClick={() => this.handleAdd(0)} >Add</a></h4></span>;

        let buffer = [];

        var cmt = this.formatComment(comment);

        buffer.push(cmt);

        return ( <div>
                {buffer}
                </div>
        );
      }
      formatRenderComments(origComment) {
        let buffer = [];

        if (!origComment)
        {
          return ( <div>
                {buffer}
                </div>
           );
        }
        var self = this;

        var stringSplit = origComment.split(" ");
        var maxLength=320;

        for(var i =0; i < stringSplit.length; i++){
            var comp = stringSplit[i];
            var firstChar = comp.charAt(0);

            if (firstChar == "#")
            {
                //buffer.push(<a href="/appstore">{comp} </a>);
                buffer.push(comp);
            }
            else if ((comp.indexOf("http://") !== -1) || (comp.indexOf("https://") !== -1))
            {
                //link
                //buffer.push(<a href={comp}>{comp} </a>);
                 buffer.push('<a href='+comp+'>'+comp+'</a>');
          

            }
            else if ((comp.indexOf("@") !== -1) || (comp.indexOf("@") !== -1))
            {
                
              //console.log(followersListing);
              //console.log(self.state.singleget_allusers);
               /*if(self.state.singleget_allusers.includes(comp))
               {
                console.log(self.state.singleget_allusers);
               }*/
              /*if (self.state.singleget_allusers) {
                for (var i = 0; i < self.state.singleget_allusers.length; i++) {
                  var display = self.state.singleget_allusers[i];
                  let displayid=display.id;
                  console.log(displayid);

                }
              }*/
              /*let linkdatas = singleget_alluserss.display.find(function(ele) {
                   ele.display === comp;
                   console.log(comp+'comp');
                   console.log(ele.display+'ele.display');
              });*/
              /*const index = singleget_allusers.display.findIndex((el) => el === comp)
              arr[index] = 0;
              if(self.state.singleget_allusers.display.includes(comp))
              {
                linkdata= self.state.singleget_allusers.display;
              }*/
               //let linkdatas='';
               /*var userdisplayname = comp.replace('@','');
               var query = new Parse.Query('_User');
               query.include("displayUsername");
               query.equalTo("displayUsername", userdisplayname);
               query.first().then(function(result){
                if(result){
                    let userdata=result;
                    let linkdatas='/user/'+userdata.get('displayUsername');
                    self.setState({linkdata:linkdatas}); 
                }
                })*/

               // let linkdata='<a href ='+this.state.linkdata+'>'+comp+'</a>';
              var userdisplayname = comp.replace('@','');
              let linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';
                  buffer.push(linkdata);  
            }
            else
            {
                                   
                   buffer.push(comp);
                
               
            }
        }
// Replace the item at the found index

// The new array with the replaced item



        var content=buffer.join(' ');
       // var data=content.length > maxLength ? `${content.substring(0, maxLength).replace(/<[^>]+>/g, "")}...` : content;
         var data=content.length > maxLength ? `${content.substring(0, maxLength)}...` : content;
       
             return ( <span className='cmt-txt'>

                {/*{buffer}*/} 
            {/* {content.length > maxLength ? `${content.substring(0, maxLength).replace(/<[^>]+>/g, "")}...` : content}*/}
              <span dangerouslySetInnerHTML={{ __html: data }} />
             {content.length > maxLength && <a href={this.state.postLink}>more</a>}
                </span>
        );
      }
      formatRenderComment(origComment,comnt_id, comment_id) {
        let buffer = [];

        if (!origComment)
        {
          return ( <div>
                {buffer}
                </div>
           );
        }


        var stringSplit = origComment.split(" ");
        var maxLength=250;

        for(var i =0; i < stringSplit.length; i++){
            var comp = stringSplit[i];
            var firstChar = comp.charAt(0);
             var self = this;
            if (firstChar == "#")
            {
                //buffer.push(<a href="/appstore">{comp} </a>);
                buffer.push(comp);
            }
            else if ((comp.indexOf("http://") !== -1) || (comp.indexOf("https://") !== -1))
            {
                //link
               // buffer.push(<a href={comp}>{comp} </a>);
                buffer.push(comp);
            }
            else if ((comp.indexOf("@") !== -1) || (comp.indexOf("@") !== -1))
            {

              /*var userdisplayname = comp.replace('@','');
               var query = new Parse.Query('_User');
               query.include("displayUsername");
               query.include("username");
               query.equalTo("displayUsername", userdisplayname);
               query.first().then(function(result){
                if(result){
                    let userdata=result;
                    let linkdatas='/user/'+userdata.get('displayUsername');
                    self.setState({linkdata:linkdatas}); 
                }
                })
                let linkdata='<a href ='+this.state.linkdata+'>'+comp+'</a>';
                  buffer.push(linkdata);  */
              var userdisplayname = comp.replace('@','');
              let linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';
                  buffer.push(linkdata);  
             }
            else
            {
                 // buffer.push(<span>{comp} </span>);  
                 //buffer.push(comp+' ');  
                 buffer.push(comp);               
            }
        }
        var content=buffer.join(' ');
            /* return ( <span className='cmt-txt'>
                {buffer}
                </span>
        );*/

        const {  showMoreText = 'more', showLessText = 'less' } = this.props;
        const { isExpanded } = this.state;
        const { expandedCommentId } = this.state;


        // Determine whether to truncate the text
        const shouldTruncate =content.length > maxLength && !isExpanded;
        
        // Truncate the text if necessary  //expandedCommentId===comment_id
        
           
        let  displayText =  shouldTruncate ? content.slice(0, maxLength) + '...' : content        
        return ( <span className='cmt-txt' id={comment_id}>
          {/*{buffer}*/} 
          {/*   {content.length > maxLength ? `${content.substring(0, maxLength).replace(/<[^>]+>/g, "") }...` :content}*/}




          {/*  {content.length > maxLength && <a href={this.state.postLink}>more</a>}*/}
          {/*expandedCommentId===comment_id*/}
          {/*displayText*/}<span dangerouslySetInnerHTML={{ __html: displayText }} />
          {/* {displayText}*/}
          {shouldTruncate   && (
              <button onClick={() => this.toggleExpand(comment_id)} style={{ color: '#868589', cursor: 'pointer', border: 'none', background: 'none' }}>
                  {isExpanded ? showLessText : showMoreText}
              </button>
          )}
          </span>
        );
      }
      formatRenderComment_old(origComment) {
        let buffer = [];

        if (!origComment)
        {
          return ( <div>
                {buffer}
                </div>
           );
        }

        var self = this;
        var stringSplit = origComment.split(" ");

        for(var i =0; i < stringSplit.length; i++){
            var comp = stringSplit[i];
            var firstChar = comp.charAt(0);

            if (firstChar == "#")
            {
                //buffer.push(<a href="/appstore">{comp} </a>);
                buffer.push(comp);
            }
            else if ((comp.indexOf("http://") !== -1) || (comp.indexOf("https://") !== -1))
            {
                //link
               // buffer.push(<a href={comp}>{comp} </a>);
                buffer.push(comp);
            }else if ((comp.indexOf("@") !== -1) || (comp.indexOf("@") !== -1))
            {
              /*var userdisplayname = comp.replace('@','');
               var query = new Parse.Query('_User');
               query.include("displayUsername");
               query.include("username");
               query.equalTo("displayUsername", userdisplayname);
               query.first().then(function(result){
                if(result){
                    let userdata=result;
                    let linkdatas='/user/'+userdata.get('displayUsername');
                    self.setState({linkdata:linkdatas}); 
                }
                })
                let linkdata='<a href ='+this.state.linkdata+'>'+comp+'</a>';
                  buffer.push(linkdata); */ 
               var userdisplayname = comp.replace('@','');
              let linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';
                  buffer.push(linkdata);  

             }
            else
            {
                  // buffer.push(<span>{comp} </span>);  
                // buffer.push(comp+' ');  
              buffer.push(comp);  
               
            }
        }
        var content=buffer.join(' ');
        return ( <span className='cmt-txt'>
        {/*buffer*/}
              <span dangerouslySetInnerHTML={{ __html: content }} />
        </span>
        );
      }
      getUsername(user) {
         /*if ((!user) || (user == undefined))
            return "User";


          user.fetch();

          var username = user.get("displayUsername");

          if ((!username) || (username.length < 2)) 
          {
            username = user.get("firstName") + "_" + user.get("lastName");
            username = username.toLowerCase(username);
          }
          if ((!username) || (username.length < 2)) 
          {
            username = "facebook_user";
          }

          return username;*/

      }
      getCommentProfilePic(comment) {
          var user = comment.get("fromUser");
          if (user && (user != undefined))
          {
            var pic = user.get("profilePictureSmall");
            if (pic && (pic != undefined))
              return pic.url()
          }
          return "/images/default_userpic0.png";
      }
      renderTitleURL() {
        if (this.state.title || this.state.url)
        {
            var urlDomain = this.state.url.replace('http://','').replace('https://','').split(/[/?#]/)[0];
            urlDomain = urlDomain.replace('www.', '');

            if (!(this.state.url && (this.state.url.length > 1)))
            {
                return ( <div>
                          <div className="titleURLContainer">
                            <div className="titleText">{this.state.title}</div>
                          </div>
                      </div>
              );
            }
            else
            {
              return ( <div>
                      <a href={this.state.url} target="_blank">
                          <div className="titleURLContainer">
                            <div className="urlText">{urlDomain}</div>
                            <div className="titleText">{this.state.title}</div>
                          </div>
                          </a>
                      </div>
              );
            }
        }
        else
        {
            //don't show this section
            return ( <div></div>
              );
        }
      }
       formatRenderComments2main(origComment) {
        let buffer = [];

        if (!origComment)
        {
          return ( <div>
                {buffer}
                </div>
           );
        }


        var stringSplit = origComment.split(" ");
        var maxLength=320;

        for(var i =0; i < stringSplit.length; i++){
            var comp = stringSplit[i];
            var firstChar = comp.charAt(0);

            if (firstChar == "#")
            {
                //buffer.push(<a href="/appstore">{comp} </a>);
                buffer.push(comp);
            }
            else if ((comp.indexOf("http://") !== -1) || (comp.indexOf("https://") !== -1))
            {
                 buffer.push('<a href='+comp+'>'+comp+'</a>');
          

            } else if ((comp.indexOf("@") !== -1) || (comp.indexOf("@") !== -1))
            {
              var userdisplayname = comp.replace('@','');
              let linkdata='<a href ='+window.location.origin+'/user/'+userdisplayname+'>'+comp+'</a>';
                  buffer.push(linkdata);  
            }

            else
            {
                                   
                   buffer.push(comp);
                
               
            }
        }
        var content=buffer.join(' ');
             return ({'a':<span className='cmt-txt'>
                        {/*  {content.length > maxLength ? `${content.substring(0, maxLength).replace(/<[^>]+>/g, "")}...` : content}
                          {content.length > maxLength && <a href={this.state.postLink}>more</a>}*/}
              {content}
                             </span>});
          //return <img src={"https:aaaa"} />
        
      }
      formatRenderComments2(origComment) {
        let buffer = [];

        if (!origComment)
        {
          return ( <div>
                {buffer}
                </div>
           );
        }


        var stringSplit = origComment.split(" ");
        var maxLength=320;

        for(var i =0; i < stringSplit.length; i++){
            var comp = stringSplit[i];
            var firstChar = comp.charAt(0);

            if (firstChar == "#")
            {
                //buffer.push(<a href="/appstore">{comp} </a>);
                buffer.push(comp);
            }
            else if ((comp.indexOf("http://") !== -1) || (comp.indexOf("https://") !== -1))
            {
                //link
                //buffer.push(<a href={comp}>{comp} </a>);
                 buffer.push('<a href='+comp+'>'+comp+'</a>');
          

            }
            else
            {
                                   
                   buffer.push(comp);
                
               
            }
        }
        var content=buffer.join(' ');
         //return ({'a':<span className='cmt-txt'>{content}</span>});
          //return '';
             return ({'a':<span className='cmt-txt'>
                             {/*{buffer}*/} 
                          {content.length > maxLength ? `${content.substring(0, maxLength).replace(/<[^>]+>/g, "")}...` : content}
                          {content.length > maxLength && <a href={this.state.postLink}>more</a>}
                             </span>});
          //return <img src={"https:aaaa"} />
        
      }
      handlePostModelOpen1 = (post_id) => {
        this.setState({post_id : post_id});
      }
      handlePostModelOpen = (post_id) => {
        
        $('#popup_post_id').val(post_id);

        $('.like-icon.liked1').attr('id','like_'+post_id);
        $('.like-icon.liked1 img.default1').attr('id','like_'+post_id);
        $('.like-icon.liked1 img.active1').attr('id','like_'+post_id);

        $('.post_save1 .savepost_link1 .savedefault1').attr('id','save_'+post_id);
        $('.post_save1 .savepost_link1 .saveactive1').attr('id','save_'+post_id);
        $('.post_save1 .savepost_link1').attr('id','save_'+post_id);
        
        //$('.like-icon.liked1 img.active1').attr('id','like_'+post_id);
        
        $('#full_text').html('');
        $('#lef_img').attr('src','../images/default_userpic0.png');
        $('.popup_user_image').attr('src','../images/default_userpic0.png');
        $('.popup_display_userimage').attr('src','../images/default_userpic0.png');
        $('.user_name a.popup_user_name').html('');
        //$(' a.popup_display_username').html('');
        
        let getLoggedinUsername=localStorage.getItem('username');
        /*if(!getLoggedinUsername)
        {
            $('#kitchenQrModal_btn').trigger('click');    
            return false;
        }else
        {*/

            var query = new Parse.Query('Photo');  
            query.include("likeCountNew");
            query.include("commentcount");
            query.equalTo('objectId', post_id);
            var self = this;

            query.find().then(function(photo){
                    if(photo)
                    {
                      //self.setState({popup_username:null});
                     
                      let photo_data=photo[0].get('caption');
                      let photo_ob  = photo[0]; 
                      let likeCountNew=photo[0].get('likeCountNew')?photo[0].get('likeCountNew'):0;
                      var likesWord = "Likes";
                      if (likeCountNew == 1) likesWord = "Like";
                      $('#like_count_new').html(likeCountNew+' '+likesWord);
                      //setTimeout(() => {
                      self.setState({likeCount:likeCountNew}); 
                       
                       // },500);
                      
                      $('.user_name a.popup_user_name').html(photo_ob.get('user').get('displayUsername'));
                      $('.user_name a.popup_user_name').attr("href", "/user/"+photo_ob.get('user').get('displayUsername')) ;
                           $('.popup_display_username').html(photo_ob.get('user').get('displayUsername'));
                        $('.popup_display_username').attr("href", "/user/"+photo_ob.get('user').get('displayUsername')) ;
                        let user_image =photo_ob.get('user').get('profilePictureSmall').url()? photo_ob.get('user').get('profilePictureSmall').url():'';
                      $('.popup_user_image').attr('src',user_image);
                        $('.popup_display_userimage').attr('src',user_image);
                      let photo_img =photo_ob.get('image').url()? photo_ob.get('image').url():'';
                      $('#lef_img').attr('src',photo_img);
                      

                        let popup_display_username=photo_ob.get('user').get('displayUsername');
                   
                      let captiondata='';
                      if(photo_ob.get('caption')!='')
                      {
                        
                         captiondata=photo_ob.get('caption');
                      }
                      if(captiondata==='')
                      {
                        captiondata=photo_data;
                      }
 //console.log(photo_ob.get('caption')+'photo_');
                       //console.log(photo_data+'captiondata');
                       let obj = captiondata!=''?self.formatRenderComments2main(captiondata):self.formatRenderComments2main(photo_data);
                       //console.log(photo_data+'photo_data');
                       //console.log(obj+'obj');
                       let full_text=obj.a.props.children?obj.a.props.children:'';
                       $('#full_text').html(full_text);
                        $('.time_interval_new').html(time_ago(photo_ob.get('createdAt')));

                       self.queryForCommentspopup(photo_ob);
                       self.handleGetLikeUser(photo_ob.id);
                       this.renderlikeuserlist();

                      

                     


                      // console.log(photo_ob.get('likeCountNew')+'likeCountNew');
                      // console.log(photo_ob.get('commentcount')+'commentcount');
                     
                     


                     
                     
                       //this.setState({likeCount1:likeCountNew}); 
                       //this.state.likeCount1=likeCountNew;
                      
                      // $('#comment_count_new').html(commentcount+' Comments')
                      //this.state.popup_username=photo_ob.get('user').get('displayUsername');
                      // this.setState({popup_username:photo_ob.get('user').get('displayUsername')}); 
                      /* $('#large_challenge_image2').addClass('show');
                      $('#large_challenge_image2').attr('style','display:block');
                        
                         let photo_img = photo_ob['attributes']['image']._url;
                         $('#lef_img').attr('src',photo_img);
                         let obj = self.formatRenderComments2(photo_ob['attributes'].caption);
                         //console.log(obj.a.props.children[0]);
                         
                         $('#full_text').html(obj.a.props.children);
                         $('.display_username').html(photo_ob['attributes']['user']['attributes'].displayUsername);
                         let likeCountNew=photo_ob['attributes'].likeCountNew;
                         let commentcount=photo_ob['attributes'].commentcount;
                         if(likeCountNew===undefined)
                         {
                          likeCountNew=0;
                         }
                         if(commentcount===undefined)
                         {
                          commentcount=0;
                         }
                         $('#like_count').html(likeCountNew+' Likes')
                         $('#comment_count').html(commentcount+' Comments');*/

                     // this.popuprenderComments();
                     

                        var query1 = new Parse.Query('Activity');
        
                        query1.equalTo("photo", photo[0]);
                        query1.equalTo("type", "comment");

                        query1.include("fromUser");
                        query1.include("image");
                        query1.include("content");
                        query1.include("_created_at");
                        query1.include("createdAt");
                         query1.descending("_created_at");
                        let buffer = [];
                        let vals = '';
                        query1.find().then(function(result1){
                          if(result1){
                            //console.log('result...................');
                            //console.log(result1);
                               self.setState({popup_comments: result1});
                             for (var i = 0; i < result1.length; i++) {
                                var comment = result1[i];
                               
                                let comment_activity_id="comment_"+comment.id;
                                let comment_id="comnt_"+comment.id;
                                let comment_fromuserid= comment.get("fromUser").id;
                                //const currentUser = Parse.User.current();
                                //let comment_currentUserId= currentUser.id;

                                buffer.push(
                                  <div key={69*i} className="cmt_wrap">
                                    <div className='usr_img_detail'>
                                      <div className='usr_img'>
                                      {/*  <img src={self.getCommentProfilePic(comment)}/>*/}                      
                                      </div>
                                      <div className="cmt_usr">
                                        <div className='name'>
                                       {/*   <a href={'/user/' + self.getUsername(comment.get("fromUser"))}>{self.getUsername(comment.get("fromUser"))}</a>*/}
                                          <span>{/*{time_ago(comment.get("createdAt"))}*/}</span>
                                        </div>
                                        <div className="action cta_btn">
                                          <div className="btn-wrp btn-group more_action three-dot">
                                            <button type="button" id="comment_dropdownlist" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                              <img src="/images/dot_action.svg" alt="More Option"/>
                                            </button>
                                            <div className="dropdown-menu dropdown-menu-right">
                                            
                                              <a href="javascript:void(0);" className="dropdown-item" type="button">Cancel</a>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                               $('#comment_show').html(<div className='cmt_wrap_list'>
                            {buffer}</div>); 

                          }


                        }, function(error){
                              console.error("Error loading comments Error: " + error);
                              //promise.error(error);
                      });
                        }
              });
         //}
      }
      queryForSinglepost() {
        var post_id=  $('#popup_post_id').val();
        var query = new Parse.Query('Photo');
        query.equalTo('objectId', post_id);
        query.include("user");
        query.include("image");
        query.include("thumbnail");
        query.include("likeCountNew");
        query.include("saveCount");
        query.include("commentcount");
        query.include("_created_at");
        query.include("createdAt");
        query.exists("user");
        query.descending("createdAt");

        var self = this;

        query.find().then(function(result){
            if(result){
                console.log(result);
                self.setState({postData: result});
                self.setState({likeCount: result[0].get('likeCountNew')});
            } else {
                console.log("No post found");
            }
        }, function(error){
        });
    }

      popuprenderComments(){
       let bufferpopup = [];
console.log('popuprenderComments');
        if (this.state.popup_comments) {
          for (var i = 0; i < this.state.popup_comments.length; i++) {
            var comment = this.state.popup_comments[i];
            let comment_activity_id="comment_"+comment.id;
            let comment_id="comnt1_"+comment.id;
            console.log(comment_activity_id+'comment_activity_id');
              console.log(comment_id+'comment_id');
            let comment_fromuserid= comment.get("fromUser").id;
           // const currentUser = Parse.User.current();
            //let comment_currentUserId= currentUser.id;
           //console.log(comment_currentUserId);
          // let full_text=comment!=undefined?comment.a!=undefined?comment.a.props.children!=undefined?comment.a.props.children:'':'':'';
           //console.log('full_text');console.log(full_text);
            bufferpopup.push(
              <div key={69*i} className="cmt_wrap1">
                <div className='usr_img_detail1'>
                  <div className='usr_img1'> ddddd
                  {/*  <img src={this.getCommentProfilePic(comment)}/> */}                     
                  </div>
                  {/*<div className="cmt_usr">
                    <div className='name'> 
                    {comment.get("fromUser").get('displayUsername')!=undefined?
                     <a href={'/user/' + comment.get("fromUser").get('displayUsername')}>{comment.get("fromUser").get('displayUsername')}</a>:""}
                      <span>{time_ago(comment.get("createdAt"))}</span>
                    </div>
                    <div className="action cta_btn">
                      <div className="btn-wrp btn-group more_action three-dot">
                        <button type="button" id="comment_dropdownlist" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <img src="/images/dot_action.svg" alt="More Option"/>
                        </button>
                        <div className="dropdown-menu dropdown-menu-right">
                          {comment_fromuserid===comment_currentUserId?<a href="javascript:void(0);"   className="dropdown-item danger" type="button" data-toggle="modal" data-target="#deleteCommentCloseModal"   onClick={(e) => this.deleteCommentId(comment_id)}   id="close_deleteCommentwithdiscard" aria-label="Modal">Delete</a> :<a href="javascript:void(0);"  className="dropdown-item danger" type="button">Report</a> }
                          <a href="javascript:void(0);" className="dropdown-item" type="button">Cancel</a>
                        </div>
                      </div>
                    </div>
                  </div>*/}
                  {/*this.formatRenderComment(comment.get("content"),comment_id,comment.id)*/}
                </div>
                {/*<div className="cmt_box">
                    <div className="cmt_cnt" id={comment_id}>{this.formatRenderComment(comment.get("content"),comment_id,comment.id)}</div>
                    <div className='comment_mn '>
                      <div className="post_action d-flex flex-column flex-wrap align-items-start w-100">
                        <div className='action_grp'>
                        
                          <a  href = "javascript:void(0);"  className='liked_activity'  id={comment_activity_id} >
                            <img data-id={comment.id} id={comment_activity_id}  onClick={(e) => {this.handlePhotoActivityLike(e);}}  className="activitydefault" src="../images/cmt-like.svg"/>
                            <img data-id={comment.id} id={comment_activity_id}  onClick={(e) => {this.handlePhotoActivityUnLike(e);}}  className="activityactive"  style={{ display: "none" }}   src="../images/like-fill.svg"/>
                            {this.handleGetActivityLikePost(comment.id)}
                          </a>
                        </div>
                        <div className='comment_count'>
                          <span className="like box">
                            <a href="#"> {this.state.singlelikeCount} {likesWord} 
                            </a>
                          </span>
                        </div>
                      </div>
                    </div>
                </div>*/}
              </div>
            );
          }
        }
         
        return ( <div className='cmt_wrap_lists'>
                {bufferpopup}
                </div>
        );

      }
  
      renderCaption() {
          if (this.props.showComments)
          {
            return ( 
              <div className="commentsContainer sngl_post_cmt">
                {/*<div className="commentTextInline">{this.formatRenderComment(this.state.caption)}</div>*/}
                <div className="cmt_wrap">
                  <div className='usr_img'>
                    <img className="userProfileImage" src={this.state.userImage}/>
                  </div>
                  <div className='cmt_box'>
                   {/* <span className="cmt_usr"><a href={'/user/' + this.getUsername(this.state.user)}>{this.getUsername(this.state.user)}</a></span>*/}
                  <span className="cmt_usr"><a href={'/user/' + this.state.getUsernamefetch}>{this.state.getUsernamefetch}</a></span>
                    <span className="cmt_cnt_full">{this.formatRenderComment_old(this.state.caption)}</span>
                    
                  </div>
                </div>
              {/* <div className="cmt_time">{time_ago(this.state.created_at)}</div>*/}
              </div>                      
            );
          }
          else
          {
            //don't show the user and timestamp on the main stream view
            return (

              <div className="commentsContainer">
              {/*<div className="commentTextInline">{this.formatRenderComment(this.state.caption)}</div>*/}
                <div className="home_pg">
                  <p className="cmt_box">
                   {/* <span className="cmt_usr"><a href={'/user/' + this.getUsername(this.state.user)}>{this.getUsername(this.state.user)}</a></span>*/}
                    <span className="cmt_usr"><a href={'/user/' + this.state.getUsernamefetch}>{this.state.getUsernamefetch}</a></span>
                    <span className="cmt_cnt">{this.formatRenderComments(this.state.caption)}</span>
                  </p>
                </div>
              </div>
            );
          }
      }
      renderRecipeAndProduct() {
        if (this.props.showComments)
        {
              return ( 
              <div>
                <Recipe recipe={this.state.recipe} />
                <Product product={this.state.product} />
               </div>
              );
        }
        else
        {
            //don't show the user and timestamp on the main stream view
            return ( 
              <div>
               </div>
              );
        }
      }
      renderUserHeaderSharedALinkOrCollab(user, url, collabUser)
      {
        let getLoggedinUsername=localStorage.getItem('username');
          if (collabUser && (collabUser != undefined))
          {
          
                return ( 
                  <div className="usernameText">
                 {/* {getLoggedinUsername===this.getUsername(user)?
                  <a href="/my-profile">{this.getUsername(user)}</a>
                  :<a href={'/user/' + this.getUsername(user)}>{this.getUsername(user)}</a>}*/}
                   {getLoggedinUsername===this.state.getUsernamefetch?
                  <a href="/my-profile">{this.state.getUsernamefetch}</a>
                  :<a href={'/user/' + this.state.getUsernamefetch}>{this.state.getUsernamefetch}</a>}
                  <span className="sharedA">
                    &nbsp;and&nbsp;</span>
                    <a href={'/user/' + collabUser}>{collabUser}</a>
                </div>
                );
          }
          else if (url)
          {
                return ( 
                  <div className="usernameText">
                {/*  {getLoggedinUsername===this.getUsername(user)?
                  <a href="my-profile"><div className="usernameText">{this.getUsername(user)}  
                  <span className="sharedA">
                    &nbsp;shared a link</span>
                </div></a>
                :
                  <a href={'/user/' + this.getUsername(user)}><div className="usernameText">{this.getUsername(user)}  
                  <span className="sharedA">
                    &nbsp;shared a link</span>
                </div></a>
              }*/}
                    {getLoggedinUsername===this.state.getUsernamefetch?
                  <a href="my-profile"><div className="usernameText">{this.state.getUsernamefetch}  
                  <span className="sharedA">
                    &nbsp;shared a link</span>
                </div></a>
                :
                  <a href={'/user/' + this.state.getUsernamefetch}><div className="usernameText">{this.state.getUsernamefetch}  
                  <span className="sharedA">
                    &nbsp;shared a link</span>
                </div></a>
              }
                </div>
                );
          }
          else
          {
              //don't show the user and timestamp on the main stream view
              return (  <div className="usernameText">
                {/*{getLoggedinUsername===this.getUsername(user)?
                <a href="/my-profile">{this.getUsername(user)}</a>:
                <a href={'/user/' + this.getUsername(user)}>{this.getUsername(user)}</a>}*/}
                {getLoggedinUsername===this.state.getUsernamefetch?
                <a href="/my-profile">{this.state.getUsernamefetch}</a>:
                <a href={'/user/' + this.state.getUsernamefetch}>{this.state.getUsernamefetch}</a>}
              </div> );
          }
      }

      handleNotLoginClick = () => {
        let getLoggedinUsername=localStorage.getItem('username');
        if(!getLoggedinUsername)
        {
            $('#kitchenQrModal_btn').trigger('click');    
            return false;
        }
      }

      singlePostModalClass() {
        $("body").addClass("sngl_mdl_open");
      }
      singlePostModalClose() {
        $("body").removeClass("sngl_mdl_open");
        $("body").removeClass("modal-open1");
        $('#popup_post_id').val('');
      }
      singlePostLikeModal() {
        $("body").addClass("sngl_mdlpstlk_open");
      }
      singlePostLikeModalClose() {
        $("body").addClass("modal-open1");
        $("body").removeClass("sngl_mdlpstlk_open");
      }

      componentDidMount(){
        document.addEventListener('keyup', (e) => {
          if ($('#large_challenge_like_list').hasClass('show') == false) {
            if (e.keyCode === 27) this.singlePostModalClose();
          }
          if ($('#large_challenge_image4').hasClass('show') == true) {
            if (e.keyCode === 27) this.singlePostLikeModalClose();
          }
        });
      }


      render() {


let bufferdata = [];
//obj.a.props.children?obj.a.props.children:'';
        if (this.state.comments_data) {
          for (var i = 0; i < this.state.comments_data.length; i++) {
            var comment = this.state.comments_data[i];
            let comment_activity_id="comment_"+comment.id;
            let comment_id="comnt_"+comment.id;
            this.state.singlelikeCount=comment.get("likeCount")?comment.get("likeCount"):0;
            var likesWord = "Likes";
            if (this.state.singlelikeCount == 1) likesWord = "Like";
            let comment_fromuserid= comment.get("fromUser").id;
            let comment_currentUserId= this.state.currentUserId;
          
            bufferdata.push(
              <div key={69*i} className="cmt_wrap">{comment.get('content')}
                <div className='usr_img_detail'>
                  <div className='usr_img'>
                    <img src={this.getCommentProfilePic(comment)}/>                      
                  }
                  </div>
                  <div className="cmt_usr">
                    <div className='name'>
                      <a href={'/user/' + this.getUsername(comment.get("fromUser"))}>{this.getUsername(comment.get("fromUser"))}</a>
                      <span>{time_ago(comment.get("createdAt"))}</span>
                    </div>
                    <div className="action cta_btn">
                      <div className="btn-wrp btn-group more_action three-dot">
                        <button type="button" id="comment_dropdownlist" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <img src="/images/dot_action.svg" alt="More Option"/>
                        </button>
                        <div className="dropdown-menu dropdown-menu-right">
                        
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cmt_box">
                    <div className="cmt_cnt" id={comment_id}>{this.formatRenderComment(comment.get("content"),comment_id,comment.id)}</div>
                    <div className='comment_mn '>
                      <div className="post_action d-flex flex-column flex-wrap align-items-start w-100">
                        <div className='action_grp'>
                          {/* <a href = "../appstore" className='liked'>
                            <img className="default" src="../images/like.svg"/>
                            <img className="active" src="../images/like-fill.svg"/>
                          </a>*/}
                        
                        
                        </div>
                        <div className='comment_count'>
                          <span className="like box">
                       
                          </span>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            );
          }
        }

        var likesWord = "Likes";
        var savesWord = "saves";
        var commentsWord = "Comments";
        var imprWord = "impressions";
        var page="home";
         var self = this;
        if(this.props.showComments) {
            page='single';
        }
        let getLoggedinUsername=localStorage.getItem('username');

        if (this.state.likeCount == 1) likesWord = "Like";
        if (this.state.saveCount == 1) savesWord = "save";
        if (this.state.commentCount == 1) commentsWord = "Comment";
        if (this.state.imprCount == 1) imprWord = "impression";

        var post_id_m='save_'+this.state.postID;
        var follow_id_m='follow_'+this.state.user.id;
        var currentuserImage=this.state.currentuserImage;
        var post_like_id_m='like_'+this.state.postID;
        var currentUserId=this.state.currentUserId;
        let sameprofile=0;
        if(currentUserId===this.state.user.id) {
          sameprofile=1;
        }
        //console.log(this.state.challengeStatus+'this.state.challengeStatus')
        var getchallengeStatus=this.state.challengeStatus;
        let ischallengeStatus=0;
        /*if(getchallengeStatus==='Active' || getchallengeStatus==='Billed')
        {
            ischallengeStatus=1;
        }*/
        //getchallengeStatus==='Active' || 
        if(getchallengeStatus==='Billed' || getchallengeStatus==='Pending' || getchallengeStatus==='Complete')
        {
            ischallengeStatus=1;
        }
        if(ischallengeStatus == 0){
          return (              
            <section className='post_list non_singlepost_top'>
                <div className='container'>
                    <div className='inner'>
                        <nav className='sidebar'>
                            <Leftsidebar/>
                        </nav>
                        <main className='single_post_page_listing listing myprofile-listing'>
                          <div className="non_single_post_main">
                            <div className="post_modal_overlay singlePostOverlayModal createPostCloseModal large_challenge_image">
                              <div className="non_single_post_inner">                            
                                <div className='inner text-center'>
                                  <div className="inner_post_row">
                                    <div className="img_leftSide">
                                      <img src="../images/default_userpic0.png" alt='Comment' />
                                    </div>
                                    <div className="right_side_content_post">
                                      <div className="user_top_row border_bottom">
                                        <div className="user_top_card">
                                          <div className="user_img">
                                            <span className="user_icon">
                                              <img src="../images/default_userpic0.png" alt='img' />
                                            </span>
                                          </div>
                                          <div className="user_name">
                                            <a href="#">rosslynmarie</a>
                                          </div>
                                        </div>
                                        <div className="action cta_btn">
                                          <div className="btn-wrp btn-group more_action three-dot">
                                            <button type="button" id="comment_dropdownlist" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                              <img src="/images/dot_action.svg" alt="More Option" />
                                            </button>
                                            <div className="dropdown-menu dropdown-menu-right">
                                              <a href="javascript:void(0);" className="dropdown-item danger" type="button">Report</a>
                                              <a href="javascript:void(0);" className="dropdown-item" type="button">Cancel</a>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <ul className="post_listing_ul">
                                        <li className="post_listing_li">
                                          <div className="detail_bottom user_top_row">
                                            <div className="user_top_card">
                                              <div className="user_inline_row">
                                                <div className="user_leftbar_img">
                                                  <div className="user_img">
                                                    <span className="user_icon">
                                                      <img src="../images/default_userpic0.png" alt='img' />
                                                    </span>
                                                  </div>
                                                  <div className="user_name">
                                                    <a href="#">rosslynmarie</a>
                                                    <span className="content-span"> Blueberry Cinnamon Rolls = Best Weekend Breakfast 😋 </span>
                                                  </div>
                                                </div>
                                                <div className="user_sidebar_heart"></div>
                                              </div>
                                              <div className="product_content_details">
                                                <div className="product_ul">
                                                  <h3 className="title">INGREDIENTS</h3>
                                                  <ul className="ul_list">
                                                    <li>
                                                      <a href="javascript:;">1 cup oat milk (warmed to bath water temp)</a>
                                                    </li>
                                                    <li>
                                                      <a href="javascript:;">1/4 cup melted vegan butter</a>
                                                    </li>
                                                    <li>
                                                      <a href="javascript:;">2 cups flour</a>
                                                    </li>
                                                    <li>
                                                      <a href="javascript:;">1/4 cup sugar</a>
                                                    </li>
                                                  </ul>
                                                </div>
                                                <div className="breakfast_tag_add">
                                                  <ul className="tag_ul">
                                                    <li>
                                                      <a href="javascript:;">#breakfast</a>
                                                    </li>
                                                    <li>
                                                      <a href="javascript:;">#vegan</a>
                                                    </li>
                                                  </ul>
                                                </div>
                                                <div className="comment_like d-flex flex-row flex-wrap align-items-center">
                                                  <div className="day box">
                                                    <a href="javascript:;">
                                                      <span className="count">6</span>
                                                      <span className="days">d</span>
                                                    </a>
                                                  </div>
                                                  <div className="like box">
                                                    <a href="javascript:;" id="like_button_challenge" onClick={this.singlePostLikeModal} type="button" data-toggle="modal" data-target="#large_challenge_like_list">
                                                      <span className="count">6</span>
                                                      <span className="like_count">Likes</span>
                                                    </a>
                                                  </div>
                                                  <div className="comment box">
                                                    <a href="javascript:;">
                                                      <span className="reply_count">Reply</span>
                                                    </a>
                                                  </div>
                                                  <div className="comment box">
                                                    <div className="action cta_btn">
                                                      <div className="btn-wrp btn-group more_action three-dot">
                                                        <button type="button" id="comment_dropdownlist" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                          <img src="/images/small_dot_action.svg" alt="More Option" />
                                                        </button>
                                                        <div className="dropdown-menu dropdown-menu-right">
                                                          <a href="javascript:void(0);" className="dropdown-item danger" type="button">Report</a>
                                                          <a href="javascript:void(0);" className="dropdown-item" type="button">Cancel</a>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="view_replies_comment">
                                                  <div class="faq-drawer">
                                                    <input class="faq-drawer__trigger" id="faq-drawer" type="checkbox" />
                                                    <label class="faq-drawer__title" for="faq-drawer">View Replies <span className="replies_count">(3)</span>
                                                    </label>
                                                    <div class="faq-drawer__content-wrapper">
                                                      <div class="faq-drawer__content">
                                                        <ul className="ul_list_replay_user">
                                                          <li className="li_list_replay_user">
                                                            <div className="comment_replay_row">
                                                              <div className="comment_user_img">
                                                                <img src="../images/default_userpic0.png" alt='user' />
                                                                <h4 className="content_replay">
                                                                  <span className="title_userName">laurencatino</span> this looks like a great option for a rainy weekend morning
                                                                </h4>
                                                              </div>
                                                              <div className="comment_user_content">
                                                                <a href="javascript:;">
                                                                  <img className="default" src="../images/cmt-like.svg" />
                                                                  <img className="active" src="../images/like-fill.svg" style={{ display: "none" }} />
                                                                </a>
                                                              </div>
                                                            </div>
                                                            <div className="comment_like d-flex flex-row flex-wrap align-items-center">
                                                              <div className="day box">
                                                                <a href="javascript:;">
                                                                  <span className="count">6</span>
                                                                  <span className="days">d</span>
                                                                </a>
                                                              </div>
                                                              <div className="like box">
                                                                <a href="javascript:;">
                                                                  <span className="count">6</span>
                                                                  <span className="like_count">Likes</span>
                                                                </a>
                                                              </div>
                                                              <div className="comment box">
                                                                <a href="javascript:;">
                                                                  <span className="reply_count">Reply</span>
                                                                </a>
                                                              </div>
                                                              <div className="comment box">
                                                                <div className="action cta_btn">
                                                                  <div className="btn-wrp btn-group more_action three-dot">
                                                                    <button type="button" id="comment_dropdownlist1" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                      <img src="/images/small_dot_action.svg" alt="More Option" />
                                                                    </button>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                      <a href="javascript:void(0);" className="dropdown-item danger" type="button">Report</a>
                                                                      <a href="javascript:void(0);" className="dropdown-item" type="button">Cancel</a>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </li>
                                                          <li className="li_list_replay_user">
                                                            <div className="comment_replay_row">
                                                              <div className="comment_user_img">
                                                                <img src="../images/default_userpic0.png" alt='user' />
                                                                <h4 className="content_replay">
                                                                  <span className="title_userName">laurencatino</span> this looks like a great option for a rainy weekend morning
                                                                </h4>
                                                              </div>
                                                              <div className="comment_user_content">
                                                                <a href="javascript:;">
                                                                  <img className="default" src="../images/cmt-like.svg" />
                                                                  <img className="active" src="../images/like-fill.svg" style={{ display: "none" }} />
                                                                </a>
                                                              </div>
                                                            </div>
                                                            <div className="comment_like d-flex flex-row flex-wrap align-items-center">
                                                              <div className="day box">
                                                                <a href="javascript:;">
                                                                  <span className="count">6</span>
                                                                  <span className="days">d</span>
                                                                </a>
                                                              </div>
                                                              <div className="like box">
                                                                <a href="javascript:;">
                                                                  <span className="count">6</span>
                                                                  <span className="like_count">Likes</span>
                                                                </a>
                                                              </div>
                                                              <div className="comment box">
                                                                <a href="javascript:;">
                                                                  <span className="reply_count">Reply</span>
                                                                </a>
                                                              </div>
                                                              <div className="comment box">
                                                                <div className="action cta_btn">
                                                                  <div className="btn-wrp btn-group more_action three-dot">
                                                                    <button type="button" id="comment_dropdownlist1" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                      <img src="/images/small_dot_action.svg" alt="More Option" />
                                                                    </button>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                      <a href="javascript:void(0);" className="dropdown-item danger" type="button">Report</a>
                                                                      <a href="javascript:void(0);" className="dropdown-item" type="button">Cancel</a>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </li>
                                        <li className="post_listing_li">
                                          <div className="detail_bottom user_top_row">
                                            <div className="user_top_card">
                                              <div className="user_inline_row">
                                                <div className="user_leftbar_img">
                                                  <div className="user_img">
                                                    <span className="user_icon">
                                                      <img src="../images/default_userpic0.png" alt='img' />
                                                    </span>
                                                  </div>
                                                  <div className="user_name">
                                                    <a href="#">JoelsKitchen</a>
                                                    <span className="content-span"> Lorem ipsum dolor sit amet! </span>
                                                  </div>
                                                </div>
                                                <div className="user_sidebar_heart">
                                                  <a href="javascript:;">
                                                    <img className="default" src="../images/cmt-like.svg" />
                                                    <img className="active" src="../images/like-fill.svg" style={{ display: "none" }} />
                                                  </a>
                                                </div>
                                              </div>
                                              <div className="product_content_details">
                                                <div className="comment_like d-flex flex-row flex-wrap align-items-center">
                                                  <div className="day box">
                                                    <a href="javascript:;">
                                                      <span className="count">6</span>
                                                      <span className="days">d</span>
                                                    </a>
                                                  </div>
                                                  <div className="like box">
                                                    <a href="javascript:;">
                                                      <span className="count">6</span>
                                                      <span className="like_count">Likes</span>
                                                    </a>
                                                  </div>
                                                  <div className="comment box">
                                                    <a href="javascript:;">
                                                      <span className="reply_count">Reply</span>
                                                    </a>
                                                  </div>
                                                  <div className="comment box">
                                                    <div className="action cta_btn">
                                                      <div className="btn-wrp btn-group more_action three-dot">
                                                        <button type="button" id="comment_dropdownlist" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                          <img src="/images/small_dot_action.svg" alt="More Option" />
                                                        </button>
                                                        <div className="dropdown-menu dropdown-menu-right">
                                                          <a href="javascript:void(0);" className="dropdown-item danger" type="button">Report</a>
                                                          <a href="javascript:void(0);" className="dropdown-item" type="button">Cancel</a>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="view_replies_comment">
                                                  <div class="faq-drawer">
                                                    <input class="faq-drawer__trigger" id="faq-drawer_new" type="checkbox" />
                                                    <label class="faq-drawer__title" for="faq-drawer_new">View Replies <span className="replies_count">(3)</span>
                                                    </label>
                                                    <div class="faq-drawer__content-wrapper">
                                                      <div class="faq-drawer__content">
                                                        <ul className="ul_list_replay_user">
                                                          <li className="li_list_replay_user">
                                                            <div className="comment_replay_row">
                                                              <div className="comment_user_img">
                                                                <img src="../images/default_userpic0.png" alt='user' />
                                                                <h4 className="content_replay">
                                                                  <span className="title_userName">laurencatino</span> this looks like a great option for a rainy weekend morning
                                                                </h4>
                                                              </div>
                                                              <div className="comment_user_content">
                                                                <a href="javascript:;">
                                                                  <img className="default" src="../images/cmt-like.svg" />
                                                                  <img className="active" src="../images/like-fill.svg" style={{ display: "none" }} />
                                                                </a>
                                                              </div>
                                                            </div>
                                                            <div className="comment_like d-flex flex-row flex-wrap align-items-center">
                                                              <div className="day box">
                                                                <a href="javascript:;">
                                                                  <span className="count">6</span>
                                                                  <span className="days">d</span>
                                                                </a>
                                                              </div>
                                                              <div className="like box">
                                                                <a href="javascript:;">
                                                                  <span className="count">6</span>
                                                                  <span className="like_count">Likes</span>
                                                                </a>
                                                              </div>
                                                              <div className="comment box">
                                                                <a href="javascript:;">
                                                                  <span className="reply_count">Reply</span>
                                                                </a>
                                                              </div>
                                                              <div className="comment box">
                                                                <div className="action cta_btn">
                                                                  <div className="btn-wrp btn-group more_action three-dot">
                                                                    <button type="button" id="comment_dropdownlist1" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                      <img src="/images/small_dot_action.svg" alt="More Option" />
                                                                    </button>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                      <a href="javascript:void(0);" className="dropdown-item danger" type="button">Report</a>
                                                                      <a href="javascript:void(0);" className="dropdown-item" type="button">Cancel</a>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </li>
                                                          <li className="li_list_replay_user">
                                                            <div className="comment_replay_row">
                                                              <div className="comment_user_img">
                                                                <img src="../images/default_userpic0.png" alt='user' />
                                                                <h4 className="content_replay">
                                                                  <span className="title_userName">laurencatino</span> this looks like a great option for a rainy weekend morning
                                                                </h4>
                                                              </div>
                                                              <div className="comment_user_content">
                                                                <a href="javascript:;">
                                                                  <img className="default" src="../images/cmt-like.svg" />
                                                                  <img className="active" src="../images/like-fill.svg" style={{ display: "none" }} />
                                                                </a>
                                                              </div>
                                                            </div>
                                                            <div className="comment_like d-flex flex-row flex-wrap align-items-center">
                                                              <div className="day box">
                                                                <a href="javascript:;">
                                                                  <span className="count">6</span>
                                                                  <span className="days">d</span>
                                                                </a>
                                                              </div>
                                                              <div className="like box">
                                                                <a href="javascript:;">
                                                                  <span className="count">6</span>
                                                                  <span className="like_count">Likes</span>
                                                                </a>
                                                              </div>
                                                              <div className="comment box">
                                                                <a href="javascript:;">
                                                                  <span className="reply_count">Reply</span>
                                                                </a>
                                                              </div>
                                                              <div className="comment box">
                                                                <div className="action cta_btn">
                                                                  <div className="btn-wrp btn-group more_action three-dot">
                                                                    <button type="button" id="comment_dropdownlist1" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                      <img src="/images/small_dot_action.svg" alt="More Option" />
                                                                    </button>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                      <a href="javascript:void(0);" className="dropdown-item danger" type="button">Report</a>
                                                                      <a href="javascript:void(0);" className="dropdown-item" type="button">Cancel</a>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </li>
                                      </ul>
                                      <div className="comment_post_bottom_add">
                                        <div className="create_challenge_row">
                                          <button className="create_button">Create Challenge</button>
                                        </div>
                                        <div className="comment_like_shere">
                                          <div class="wrapper d-flex flex-row flex-wrap align-items-center justify-content-between w-100">
                                            <div class="action_grp">
                                              <a href="javascript:;" class="like-icon liked">
                                                <img class="default" src="../images/like-bold.svg" />
                                                <img class="active" src="../images/like-fill.svg" style={{ display: "none" }} />
                                              </a>
                                              <a href="javascript:;" class="comment-icon home-comment">
                                                <img src="../images/comment-bold.svg" alt="Comment" />
                                              </a>
                                              <a href="javascript:;" class="share-icon">
                                                <img src="../images/cmt-share-bold.svg" alt="Share" />
                                              </a>
                                            </div>
                                            <div class="post_save">
                                              <a href="javascript:;" class="savepost_link">
                                                <img class="savedefault" src="../images/bookmark-bold.png" alt="No BookMark" />
                                                <img class="saveactive" src="../images/bookmark-fill.svg" alt="No BookMark" style={{ display: "none" }} />
                                              </a>
                                            </div>
                                          </div>
                                          <p className="liked_others">
                                            Liked by <a href="javascript:;">laurencatino</a> and <a href="javascript:;" id="like_button_challenge" onClick={this.singlePostLikeModal} type="button" data-toggle="modal" data-target="#large_challenge_like_list">99 others</a>
                                          </p>
                                        </div>
                                        <div className="add_in_comment">
                                          <div className="emoji_icon_input_row">
                                            <div className="emogi_icon">
                                              <img src="../images/add_reaction.svg" alt='img' />
                                            </div>
                                            <input type="text" placeholder="Add a comment..." name="text" />
                                            <button className="post_button_comment">Post</button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <hr className="border_hr" />
                          <div className="border_hr"></div>

                          <div className="row">
                            <div className="col-md-12">
                              <div className="more_post_section">
                                <h3 className="more_post_title">More posts from <a className="username" href="javascript:;">rosslynmarie</a></h3>
                                <div className="more_post_list">
                                  <div className="grid_post_row">
                                    <div className="grid_post">
                                      <a href="javascript:;">
                                        <figure class="thumbnail">
                                          <img src="/images/slider_one.jpg" />
                                        </figure>
                                      </a>
                                    </div>
                                    <div className="grid_post">
                                      <a href="javascript:;">
                                        <figure class="thumbnail">
                                          <img src="/images/slider_one.jpg" />
                                        </figure>
                                      </a>
                                    </div>
                                    <div className="grid_post">
                                      <a href="javascript:;">
                                        <figure class="thumbnail">
                                          <img src="/images/slider_one.jpg" />
                                        </figure>
                                      </a>
                                    </div>
                                    <div className="grid_post">
                                      <a href="javascript:;">
                                        <figure class="thumbnail">
                                          <img src="/images/slider_one.jpg" />
                                        </figure>
                                      </a>
                                    </div>
                                    <div className="grid_post">
                                      <a href="javascript:;">
                                        <figure class="thumbnail">
                                          <img src="/images/slider_one.jpg" />
                                        </figure>
                                      </a>
                                    </div>
                                    <div className="grid_post">
                                      <a href="javascript:;">
                                        <figure class="thumbnail">
                                          <img src="/images/slider_one.jpg" />
                                        </figure>
                                      </a>
                                    </div>
                                  </div>                            
                                </div>
                              </div>
                            </div>
                          </div>

                          
                        </main>                     
                    </div>
                </div>
            </section>
          );
          }else{

            return(<span></span>);
          }
      }
}



export default Singlepostoverly;



// WEBPACK FOOTER //
// ./src/Singlepostoverly.jsx